import { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
import { useSelector } from 'react-redux'
// import { LineChart } from '@mui/x-charts/LineChart';
// import * as XLSX from 'xlsx';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// import TableToExcel from "@linways/table-to-excel";

// import html2pdf from 'html2pdf.js';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// import ApexCharts from 'react-apexcharts';
import Chart from "react-apexcharts";
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Grid, Container, Typography, Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  Card,
  CardContent,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Box,
  TextField,
  ClickAwayListener,
  InputBase,
  Switch,
  Modal,
  Divider,

} from '@mui/material';
// components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// sections
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';
import Iconify from '../components/iconify';
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';

import { Api, UploadFile } from '../webservices';

// ----------------------------------------------------------------------
const tablebg = 'rgba(82, 130, 190, 0.08)';
export default function DashboardAppPage() {
  const Role = useSelector((state) => state.userData.data?.role)

  console.log("kki", Role)
  const clientAccess = useSelector((state) => state.userData.data?.accessRights?.clients)
  const individual = useSelector((state) => state.userData.data)

  // console.log("individual", individual?.contactPersonName)
  const recruiterRoles = ["recruiterHead", "recruiterManager", "recruiterTeamLead", "recruiter", "recruiterTrainee"];
  const salesRoles = ["salesHead", "salesManager", "salesTeamLead", "salesExecutive", "salesTrainee"];

  const theme = useTheme();
  const token = localStorage.getItem('token');
  // const userId = '';
  const userType = localStorage.getItem('userType');
  // const [tab, setTab] = useState(userType === 'benchSales' ? 'bench' : 'recruitment');

  const getDefaultTab = (role) => {
    const recruitmentRoles = [
      'recruiterTrainee',
      'recruiterHead',
      'recruiterManager',
      'recruiterTeamLead',
      'recruiter',
      'admin',
    ];
    const salesRoles = [
      'salesTrainee',
      'salesHead',
      'salesManager',
      'salesTeamLead',
      'sales',
      'admin',
    ];



    if (role === 'benchSales') return 'bench';
    if (recruitmentRoles.includes(role)) return 'recruitment';
    if (recruitmentRoles.includes(role)) return 'placement';
    if (salesRoles.includes(role)) return 'sales';




    return 'recruitment';
  };

  const [tab, setTab] = useState(getDefaultTab(Role));







  const [recTable, setRecTable] = useState([]);
  const [recRaddial, setRecRaddial] = useState();
  const [saleRaddial, setSaleRaddial] = useState();
  const [saleRaddial1, setSaleRaddial1] = useState();
  const [saleTable, setSaleTable] = useState([]);
  const [Users, setUsers] = useState([]);
  const [per, setPer] = useState({})
  const [totall, setTotall] = useState([]);
  const [totall2, setTotall2] = useState([]);
  const [allSLData, setAllSLData] = useState([]);
  const [totals, setTotalSLData] = useState([]);

  const [salesxlsx, setSalesxlsx] = useState([])
  const [salesxlsxT, setSalesxlsxT] = useState([])
  const [salesxlsx1, setSalesxlsx1] = useState([])
  const [salesxlsxT1, setSalesxlsxT1] = useState([])

  const [ApiByCond, setApiByCond] = useState(false)
  const [totallSales, setTotallSales] = useState([]);
  const [clientRad, setClientRaddial] = useState([])
  const [clientRadDate, setClientRaddialDate] = useState([])
  const [benchRad, setBenchRaddial] = useState([])
  const [benchRadDate, setBenchRaddialDate] = useState([])

  const [placementPieChartData, setPlacementPieChartData] = useState([])
  const [placementPieChartDate, setPlacementPieChartDate] = useState([])
  const [placementGrandTotal, setPlacementGrandTotal] = useState('')

  const styleSkillsetDown = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '40%', sm: '55%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    //     paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  // console.log("======benchRad", benchRad)
  // console.log("======benchRadDate", benchRadDate)

  useEffect(() => {

    getPieChart()
    // if (recruiterRoles.includes(Role)) {
    //   setTab('recruitment');
    // } else if (salesRoles.includes(Role)) {
    //   setTab('sales');
    // } else if (Role === 'admin') {
    //   setTab('recruitment');
    // }
    getRecBar()
    getRecRadial()
    getDashboardPercentage()
    // getClients()
    // getBenchClients()
    getBenchPercentage()

    const currentDate = dayjs();
    const oneMonthAgo = currentDate.subtract(1, 'day');
    setValuee({
      fromDate: oneMonthAgo,
      tillDate: currentDate
    });
    setValueee({
      fromDate: oneMonthAgo,
      tillDate: currentDate
    });
    setValueeee({
      fromDate: oneMonthAgo,
      tillDate: currentDate
    });
    setValueeeee({
      fromDate: oneMonthAgo,
      tillDate: currentDate
    });
  }, []);

  // console.log("userData ===>>>", Role)

  const [rec, setRec] = useState({



    // timePeriod: 'week',
    placement: "recruitor",
    timePeriod: 'day',
    // timePeriod: 'year',
    allUser: '',
    tempRole: '',
    teamUser: '',
    isTeam: localStorage.getItem("typeUser") === "individual" ? "individual" : 'all',
    userId: '',
    cid: '',
    // fromDate:"",
    // tillDate:""
    // fromDate: oneMonthAgo.toISOString(),
    // tillDate: today.toISOString()

    fromDate: '',
    tillDate: ''
  });
  const [valuee, setValuee] = useState({ fromDate: '', tillDate: '' })

  const [sal, setSal] = useState({

    fromDate: dayjs().subtract(1, 'day').toISOString(),
    tillDate: dayjs().toISOString()

  });

  const [client, setClient] = useState({

    fromDate: '',
    tillDate: ''

  });

  // useEffect(() => {
  //   const currentDate = dayjs();
  //   const oneMonthAgo = currentDate.subtract(1, 'day');
  //   setValuee({
  //     fromDate: oneMonthAgo,
  //     tillDate: currentDate
  //   });
  //   setValueee({
  //     fromDate: oneMonthAgo,
  //     tillDate: currentDate
  //   });
  //   setValueeee({
  //     fromDate: oneMonthAgo,
  //     tillDate: currentDate
  //   });
  // }, []);

  const [valueee, setValueee] = useState({ fromDate: '', tillDate: '' })
  const [valueeee, setValueeee] = useState({ fromDate: '', tillDate: '' })
  const [valueeeee, setValueeeee] = useState({ fromDate: '', tillDate: '' })

  useEffect(() => {
    // if(tab === "recruitment"){

    // recTableByDate();
    setTimeout(() => {
      recTableByDate();
    }, 500)
    // }

  }, [valuee.fromDate, valuee.tillDate]);

  // const [fromDate, setFromDate] = useState()
  useEffect(() => {
    if (tab === "sales") {

      allTableByDate()
    }
    // salTableByDate();
  }, [valueee.fromDate, valueee.tillDate]);

  useEffect(() => {
    if (tab === "re") {
      // alert("re")
      clientTableByDate()
    }
  }, [valueeee.fromDate, valueeee.tillDate])

  useEffect(() => {
    if (tab === "bench") {
      // alert("bench")
      benchTableByDate()
    }

  }, [valueeee.fromDate, valueeee.tillDate])

  const [rbar, setRbar] = useState([])
  const [rbarclient, setRbarClient] = useState([])
  const [rbarbench, setRbarBench] = useState([])
  const [sbar, setSbar] = useState([])

  // console.log("==========rbarbench", rbarbench)
  // console.log("valueee.fromDate==>>>", valueee.fromDate)
  // console.log("valueee.tillDate==>>>", valueee.tillDate)

  // useEffect(() => {
  //   handleTab("sales")

  //   setTimeout(() => {
  //     getDashboardPercentage()
  //     handleTab("recruitment")
  //   }, 3000) 
  //   // getRecRadial()
  //   // getDashboardPercentage()
  //   // getRecBar()   
  //   // recTableByDate()

  // }, []);

  const [benchPer, setBenchPer] = useState([])

  const getBenchPercentage = async () => {
    const body = {
      "amount": "1",
      // "unit": "year",
      "unit": "month"
    }
    Api(`bench/BenchPercentage`, 'POST', body, token)
      .then((response) => {
        // console.log("muz---------->>>>>", response)

        setBenchPer(response.data)
        if (response.code === 200) {
          if (response.data.code === 200) {
            // console.log("--------------->>>>>", response)

          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  // console.log("benchPer===========", benchPer.RecruitementPercenatge)

  const getDashboardPercentage = async () => {
    const body = {
      "amount": "1",
      // "unit": "year",
      "unit": "month",

    }
    Api(`common/percentage`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            // console.log("ashishg---------------->>>>>", response)
            setPer(response.data);
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }
  const [disrole, setDisRole] = useState(true)
  const handleRole = (val) => {
    Api(`company/userbyrole/${val}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setUsers(Response.data.data);
            setDisRole(true)
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
        // alert("gg")
        toast.warn(Response.data.message);
        setDisRole(false)
      }
    });
  };

  const handleUser = () => {
    Api(`common/users/${tab === 'recruitment' ? 'RC' : 'SL'}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setUsers(Response.data.data);
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  };

  const getRecBarClient = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "clientId": id || rec.userId || rec.cid || individual?._id
    }
    Api(`common/CoudataAndntsByClientBar`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setRbarClient(response.data.result);
          if (response.data.code === 200) {
            // alert("ll")
            // setRbar(response.data.inRangedTotalForAllUsers);
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  const getRecRadialClient = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "clientId": id || rec.userId || rec.cid || individual?._id,
    }
    Api(`common/dataAndCountsByClientRED`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setClientRaddial(response.data.result)
          setClientRaddialDate(response.data)
          if (response.data.code === 200) {
            // setRecRaddial(response.data);
            // setRecTable(response.data.recruitement);
            // setTotall(response.data)
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  const getRecBar = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id
    }
    Api(`common/dash/rbar`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setRbar(response.data.inRangedTotalForAllUsers);
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  const getRecRadial = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
    }
    Api(`common/dash/rec`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setRecRaddial(response.data);
            setRecTable(response.data.recruitement);
            // setTotall(response.data)
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  const [pieChartData, setPieChartData] = useState([])

  // console.log("tab", tab)

  const getPieChart = async (tp, type) => {
    // console.log("tp", tp)
    // console.log("rec.timePeriod", rec.timePeriod)
    const body =
    // {
    //   "unit": tp || rec.timePeriod,
    //   "dataOf": t || rec.isTeam,
    //   "userId": id || rec.userId || individual?._id ,
    // }

    {
      "type": type || "recruitor",
      "unit": tp || "day",
      "startDate": new Date().toISOString()
    }

    Api(`common/piechart`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 200) {
            setPieChartData(response.data.result);

          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  // console.log("pieChartData", pieChartData)

  // console.log("dateObject.fromDate===>>>", recRaddial?.dateObject?.fromDate);
  // console.log("dateObject.tillDate===>>>", recRaddial?.dateObject?.tillDate);


  const getRecRadialBench = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || rec.cid || individual?._id,
    }
    Api(`bench/dataAndCountsByBenchRED`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setBenchRaddial(response.data.result)
          setBenchRaddialDate(response.data)
          if (response.data.code === 200) {
            // setRecRaddial(response.data);
            // setRecTable(response.data.recruitement);
            // setTotall(response.data)
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }


  // console.log("total===>>>", totall);
  // console.log("totallSales====>>>", totallSales)
  // console.log("saleRaddial===>>===", saleRaddial)

  const getSaleRadial = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
    }
    Api(`common/dash/sl`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setSaleRaddial(response.data.totalSales);
            setSaleRaddial1(response.data);
            setSaleTable(response.data.salesSideUsers);
            // setTotallSales(response.data.totalSales)
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  const handleTab = (tab) => {
    setButtonLabel("All")

    setRec({
      // timePeriod: 'week',
      timePeriod: 'day',
      placement: "recruitor",

      // timePeriod: 'year',
      allUser: 'all',
      tempRole: '',
      teamUser: '',
      // isTeam: 'all',
      isTeam: localStorage.getItem("typeUser") === "individual" ? "individual" : 'all',
      userId: '',
    })


    setTab(tab)
    setActive('active')
    if (tab === 'recruitment') {
      getRecRadial()
      getRecBar()
      recTableByDate()
      getPieChart('', "recruitor")
      getDashboardPercentage();
    } else if (tab === 'sales') {
      getSaleRadial()
      // salTableByDate();
      allTableByDate();
      getSalesBar()
      getPieChart('', "sales")
      getDashboardPercentage();
    } else if (tab === "re") {
      // alert("KK")
      // handleTab('re') 
      // console.log("=======", tab)
      getClients()
      // getRecBarClient()
      getRecRadialClient()
      clientTableByDate()
      getDashboardPercentage();
    } else if (tab === "bench") {
      getBenchPercentage()
      getPieChart('', "bench")
      benchTableByDate()
      getBenchBar()
      getRecRadialBench()

      getBenchClients()
      // alert("ben")
      // handleTab('bench')
      // recTableByDate()
    }
    else if (tab === "placement") {
      //   getBenchPercentage()
      //  getPieChart('', "bench")
      //   benchTableByDate()
      //  getBenchBar()
      getPlacementBar()
      placementPieChart1();
      placementTableData();

      //   getRecRadialBench()

      //  getBenchClients()  
    }
  }






  // useEffect(() => {
  //   handleTab("sales");

  //   if (!salesRoles.includes(Role)) {
  //     setTimeout(() => { 
  //       getDashboardPercentage();
  //       handleTab("recruitment");
  //     }, 3000);
  //   } else {
  //     // setTimeout(() => {
  //     getDashboardPercentage();
  //     // }, 1000);
  //   }

  //   // Uncomment the following lines if you want to call these functions as well
  //   // getRecRadial();
  //   // getRecBar();
  //   // recTableByDate();
  // }, []);

  // const [selectedDropdownValue, setSelectedDropdownValue] = useState('recruitment');

  const getDefaultDropdownValue = (role) => {
    const recruitmentRoles = [
      'recruiterTrainee',
      'recruiterHead',
      'recruiterManager',
      'recruiterTeamLead',
      'recruiter',
      'admin',
    ];
    const salesRoles = [
      'salesTrainee',
      'salesHead',
      'salesManager',
      'salesTeamLead',
      'sales',
      'admin',
    ];

    if (recruitmentRoles.includes(role)) return 'recruitment';
    if (salesRoles.includes(role)) return 'sales';
    return '';
  };

  const [selectedDropdownValue, setSelectedDropdownValue] = useState(getDefaultDropdownValue(Role));

  const handleChangeDrop = (event) => {
    setButtonLabel("All")
    const selectedTab = event.target.value.toLowerCase();
    // setTab(selectedTab);
    setSelectedDropdownValue(selectedTab)
  }
  const Funcc = () => {
    setActive('active')
    const selectedTab = selectedDropdownValue.toLowerCase();
    if (selectedTab === 'recruitment') {
      getPieChart('', "recruitor")
      setTab(selectedTab);
      getRecRadial();
      getRecBar();
      recTableByDate();
      getDashboardPercentage();
    } else if (selectedTab === 'sales') {
      getPieChart('', "sales")
      setTab(selectedTab);
      getSaleRadial();
      getSalesBar();
      salTableByDate();
      getDashboardPercentage();
      // } else if (selectedTab === 'item orders') {
    } else if (selectedTab === 'clients') {
      // handleTab('re')
      setTab("re");
      getDashboardPercentage();
      // getRecBarClient()
      getRecRadialClient()
      clientTableByDate()
    } else if (selectedTab === 'bench') {
      getPieChart('', "bench")
      setTab("bench");
      getBenchPercentage()
      // recTableByDate()
      benchTableByDate()
      getBenchBar()
      getRecRadialBench()

      getBenchClients()
      // alert("bench")
    } else if ((selectedTab === 'placement')) {
      setTab("placement");
      getPlacementBar();
      placementPieChart1();
      placementTableData();
    }
  }

  // console.log("selectedTab===>>", selectedTab)

  const getAll = async (val, id, tp) => {
    if (tab === 'recruitment') {
      getRecRadial(val, id, tp)
      getRecBar(val, id, tp)
      getDashboardPercentage();
      getPieChart(tp, 'recruitor')
    } else if (tab === 'sales') {
      getSaleRadial(val, id, tp)
      getSalesBar(val, id, tp)
      getDashboardPercentage();
      getPieChart(tp, 'sales')
    } else if (tab === "re") {
      getClients()
      // getRecBarClient(val, id, tp)
      getRecRadialClient(val, id, tp)
      getDashboardPercentage();
    } else if (tab === "bench") {
      getBenchBar(val, id, tp)
      getRecRadialBench(val, id, tp)
      getPieChart(tp, 'bench')
      getBenchPercentage();
      getBenchClients();
    }
    else if (tab === "placement") {
      getPlacementBar(val, id, tp);
      placementPieChart1(val, id, tp);
      placementTableData("", "", val);

    }
  }















  const getSalesBar = async (t, id, tp) => {
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id
    }
    Api(`common/dash/sbar`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setSbar(response.data.inRangedTotalForAllUsers);
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }



  const getBenchBar = async (t, id, tp) => {
    // alert("kk")
    const body = {
      "unit": tp || rec.timePeriod,
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
      "fromDate": '',
      "tillDate": ''
    }
    Api(`bench/dataAndCountsByClientBar`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setRbarBench(response.data.result)

          if (response.data.code === 200) {
            // setSbar(response.data.inRangedTotalForAllUsers);
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }



  const [tableByDate, setTableByDate] = useState([])
  const [tableByDate2, setTableByDate2] = useState([])
  const [tableByDate1, setTableByDate1] = useState([])

  const [tableByDateClient, setTableByDateClient] = useState([])
  const [tableByDateClientTotal, setTableByDateClientTotal] = useState([])

  // console.log("---------tableByDateClient", tableByDateClient)
  // console.log("---------tableByDateClientTotal", tableByDateClientTotal)

  // console.log("tableByDate===>>>>+++", tableByDate)
  // console.log("fromDate===>>>>+++", rec.fromDate)
  // console.log("tillDate===>>>>+++", rec.tillDate)

  // console.log("tillDate+++", new Date(rec.tillDate).toLocaleDateString("en-US",
  //   { month: "2-digit", day: "2-digit", year: "numeric" }));

  // const recDate = new Date(rec.tillDate).toLocaleDateString("en-US",
  //   { month: "2-digit", day: "2-digit", year: "numeric" })

  // console.log("fromDate+++", new Date(rec.fromDate).toLocaleDateString("en-US",
  //   { month: "2-digit", day: "2-digit", year: "numeric" }));

  // const salDate = new Date(rec.fromDate).toLocaleDateString("en-US",
  //   { month: "2-digit", day: "2-digit", year: "numeric" })

  // useEffect(() => {
  //   if (rec.userId) {
  //     getAll(rec.isTeam, rec.userId);
  //     recTableByDate(rec.isTeam, rec.userId);
  //     salTableByDate(rec.isTeam, rec.userId);
  //     benchTableByDate(rec.isTeam, rec.userId)
  //   } else {
  //     // clientTableByDate("", rec.cid);
  //     // getRecBarClient()
  //     // getRecRadialClient()
  //     // getRecRadialBench()

  //   }
  //   // allTableByDate();

  // }, [rec.userId, rec.cid]);

  const handleChange = (e) => {
    // alert(e.target.value)
    // setRec({ ...rec, userId: e.target.value }); 
    if (tab !== "re") {
      setRec({ ...rec, userId: e.target.value });
    } else {
      setRec({ ...rec, cid: e.target.value });
    }

  };

  const [active, setActive] = useState('active');
  const [buttonLabel, setButtonLabel] = useState('All');

  useEffect(() => {
    if (tab === "recruitment") {
      setTableByDate([]);
      setTotall([]);
      recTableByDate('', '');
    } else if (tab === "bench") {
      setTableByDate2([]);
      setTotall2([]);
      benchTableByDate('', '');
    } else if (tab === "sales") {
      setTableByDate1([]);
      setTotallSales([]);
      salTableByDate('', '');
    } else {
      getClients()
      setTableByDateClient([]);
      setTableByDateClientTotal([]);
      clientTableByDate('', '');
    }
  }, [active]);

  const toggleButtonLabel = () => {
    setButtonLabel((prevLabel) => {
      const newLabel = prevLabel === 'Active' ? 'All' : 'Active';
      setActive(newLabel === 'Active' ? '' : 'active');
      return newLabel;
    });
  };

  const recTableByDate = async (t, id) => {
    const body = {
      // "dataOf": "all",
      // "userId": "",
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
      "fromDate": valuee.fromDate || rec.fromDate || '',
      "tillDate": valuee.tillDate || rec.tillDate || '',
      "status": active,
    };

    Api(`common/dash/rec/table`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setTableByDate(response.data.RecruiterTable);
            setTotall(response.data)
          } else {
            // toast.warn(response.data.message + '!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err + '!');
      });
  };

  const allTableByDate = async (t, id) => {

    setAllSLData([])

    setTotalSLData([])
    setSalesxlsx1([])
    setSalesxlsxT1([])

    // const salTableByDate = async (t, id) => {
    // console.log("all Users=======================>>", id);
    const body = {
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
      "fromDate": valueee.fromDate || sal.fromDate || '',
      "tillDate": valueee.tillDate || sal.tillDate || '',
      "status": active,
    };

    Api(`common/dash/sl/table/all`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setTableByDate([]);
            // setAllSLData(response.data.data)
            setAllSLData(response.data.response)
            const totalsData = {
              new: 0,
              passive: 0,
              meeting: 0,
              converted: 0,
              pipeline: 0,

            };

            const totals = {
              totalNew: 0,
              totalPipeline: 0,
              totalMeetings: 0,
              totalConverted: 0,
              totalPassiveclient: 0
            }
            response.data.data.forEach((item) => {
              const { new: newStatus, pipeline: newPipeline, meeting: newMeetings, converted: newConverted, passive: newPassiveclient } = item.statuses;

              totals.totalNew += newStatus;
              totals.totalPipeline += newPipeline;
              totals.totalMeetings += newMeetings;
              totals.totalConverted += newConverted;
              totals.totalPassiveclient += newPassiveclient;

              // console.log("data=========>>", newStatus);
            });

            response.data.response.forEach(entry => {
              totalsData.new += entry.new;
              totalsData.passive += entry.passive;
              totalsData.meeting += entry.meeting;
              totalsData.pipeline += entry.pipeline;
              totalsData.converted += entry.converted;
            });
            setSalesxlsx1(response.data.response)
            setSalesxlsxT1(totalsData)

            setTotalSLData(totals)

            // console.log("Totals object: ", totals);
            // setTotall(response.data)
          } else {
            // toast.warn(response.data.message + '!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err + '!');
      });
  };

  const clientTableByDate = async (t, id) => {
    const body = {
      // "dataOf": "all",
      // "userId": "",

      "dataOf": t || rec.isTeam,
      "clientId": id || rec.userId || rec.cid,
      "fromDate": valueeee.fromDate || client.fromDate || '',
      "tillDate": valueeee.tillDate || client.tillDate || '',
      "status": active
    };
    Api(`common/dataAndCountsByClientTable`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.status === 200) {
          setTableByDateClientTotal(response.data.totalCountObject)
          setTableByDateClient(response.data.result)
          if (response.data.status === 200) {
            // setTableByDate1(response.data.salesTable);
            // setTotallSales(response.data.totalSales)
          } else {
            // toast.warn(response.data.message + '!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err + '!');
      });
  };
  const [benchTable, setBenchTable] = useState('')

  const benchTableByDate = async (t, id) => {
    const body = {
      // "dataOf": "all",
      // "userId": "",   
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
      "fromDate": valueeee.fromDate || client.fromDate || '',
      "tillDate": valueeee.tillDate || client.tillDate || '',
      "status": active,
    };

    Api(`bench/dataAndCountsByBenchRecTable`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setTableByDate2(response.data.RecruiterTable);
            setTotall2(response.data)
          } else {
            // toast.warn(response.data.message + '!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err + '!');
      });
  };

  // console.log(" >>>>>>>>>> rec.isTeam >>>>>>>>>>", rec.isTeam)

  const salTableByDate = async (t, id) => {
    setSalesxlsx([])
    setSalesxlsxT([])

    setTableByDate1([]);
    setTotallSales([])

    const body = {
      // "dataOf": "all",
      // "userId": "",
      "dataOf": t || rec.isTeam,
      "userId": id || rec.userId || individual?._id,
      "fromDate": valueee.fromDate || sal.fromDate || '',
      "tillDate": valueee.tillDate || sal.tillDate || '',
      "status": active,
    };
    Api(`common/dash/sl/table`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setSalesxlsx(response.data.salesTable)
            setSalesxlsxT(response.data.totalSales)

            setTableByDate1(response.data.salesTable);
            setTotallSales(response.data.totalSales)

          } else {
            // toast.warn(response.data.message + '!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err + '!');
      });
  };

  const [clientList, setClientList] = useState([])

  // console.log("=================clientList", clientList)

  const getClients = () => {
    const token1 = localStorage.getItem('token');
    Api('common/getClientList', 'GET', '', token1).then((response) => {
      if (response.status === 200) {
        // alert("jj")
        setClientList(response.data.result);
        if (response.result.length) {
          setClientList(response.result);
        } else {
          setClientList([]);
        }
      } else {
        // toast.warn(Response.error + '!');
      }
    }).catch((error) => {
      // toast.error('Failed to fetch clients! ' + error.message);
    });
  };

  const [benclientList, setBenClientList] = useState([])

  const getBenchClients = () => {
    const token1 = localStorage.getItem('token');
    Api('bench/UserDropDownList/BWS', 'GET', '', token1).then((response) => {
      if (response.status === 200) {
        // alert("jj")
        setBenClientList(response.data.data);
        if (response.result.length) {
          setBenClientList(response.data);
        } else {
          setBenClientList([]);
        }
      } else {
        // toast.warn(Response.error + '!');
      }
    }).catch((error) => {
      // toast.error('Failed to fetch clients! ' + error.message);
    });
  };

  // console.log("=====benclientList", benclientList)

  // const getClients = () => {
  //   const body = {
  //     status: "",
  //     page: 1,
  //     limit: '35',
  //   };
  //   const token1 = localStorage.getItem('token');
  //   Api('company/direct_converted', 'POST', body, token1).then((Response) => {
  //     if (Response.status === 200) {
  //       if (Response.data.code === 200) {
  //         if (Response.data.data.length) {
  //           setClientList(Response.data.data);
  //         } else {
  //           // setClientList([])
  //         }
  //       }
  //     } else {
  //       toast.warn(Response.data.error, +'!');
  //     }
  //   });
  // };

  const handleDateChange = (date, field) => {
    // const isoString = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    const isoString = dayjs(date).toISOString();
    setValuee((prevRec) => ({
      ...prevRec,
      [field]: isoString
    }));
    // console.log("isoString====>>>>", isoString)
  };

  const handleDateChange1 = (date, field) => {
    // const isoString = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    const isoString = dayjs(date).toISOString();
    setValueee((prevRec) => ({
      ...prevRec,
      [field]: isoString
    }));
  };

  const handleDateChange2 = (date, field) => {
    // const isoString = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    const isoString = dayjs(date).toISOString();
    setValueeee((prevRec) => ({
      ...prevRec,
      [field]: isoString
    }));

  };

  const handleDateChange3 = (date, field) => {
    // const isoString = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    const isoString = dayjs(date).toISOString();
    setValueeeee((prevRec) => ({
      ...prevRec,
      [field]: isoString
    }));

  };

  const style = {
    bgcolor: 'background.paper',
    border: '1.5px solid #3C6BA5',
    // boxShadow: 5,
    fontSize: "29px"
  }

  const rect = ["recruiterHead", "recruiterManager", "recruiterTeamLead", "recruiter"]

  const saless = ["salesHead", "salesManager", "salesTeamLead", "salesExecutive"]


  const ShowDataRec = (tab === 'recruitment' && (
    Role === 'recruiterTrainee' ||
    Role === 'recruiterHead' ||
    Role === 'recruiterManager' ||
    Role === 'recruiterTeamLead' ||
    Role === 'recruiter' ||
    Role === 'admin'
  )) || Role === 'admin' || localStorage.getItem("typeUser") === "individual" &&
    localStorage.getItem("role") === "admin"

  // const ShowDataSal = (tab === 'sales' && (
  //   Role === 'salesTrainee' ||
  //   Role === 'salesHead' ||
  //   Role === 'salesManager' ||
  //   Role === 'salesTeamLead' ||
  //   Role === 'sales' ||
  //   Role === 'admin'
  // )) || Role === 'admin' || localStorage.getItem("typeUser") === "individual" &&
  //   localStorage.getItem("role") === "admin";

  const ShowDataSal = (

    Role === 'salesTrainee' ||
    Role === 'salesHead' ||
    Role === 'salesManager' ||
    Role === 'salesTeamLead' ||
    Role === 'sales' ||
    Role === 'admin'
    ||
    Role === 'admin' ||
    (
      localStorage.getItem("typeUser") === "individual" &&
      localStorage.getItem("role") === "admin"
    )
  );

  // console.log("Role", Role)
  // console.log("rbar?.date", rbar.map((item) => item.date))
  // console.log("rbar?.date", rbar[0].date)

  // console.log("benchRad?.placementCount", benchRad?.placementCount)

  // userType === 'benchSales

  const chartData1 = {
    options: {
      chart: {
        id: "basic-line-chart",
        toolbar: {
          show: false,
        },
      },
      title: {
        text: 'Recruitment Status',
        align: 'center',
        style: {
          fontSize: '21px',
          color: '#3C6BA5',
          fontWeight: 'normal',
          // paddingTop:"15px"
        },
      },
      xaxis: {
        categories: [0, 1, 5, 12, 4, 5, 2, 7, 8, 9, 11, 3, 10, 6, 13],
      },
    },
    series: [
      {
        data: [0, 2, 0, 4, 1, 9, 8, 6, 5, 11, 13, 10, 12, 3, 7],
      },
    ],
  };


  const data = {
    "status": 200,
    "resmessage": "result of pie chart find successfully",
    "result": [
      { "totalActivity": 0, "startTime": "3/1/2025, 12:00:00 AM", "endTime": "3/1/2025, 12:59:59 AM" },
      { "totalActivity": 40, "startTime": "3/1/2025, 1:00:00 AM", "endTime": "3/1/2025, 1:59:59 AM" },
      { "totalActivity": 0, "startTime": "3/1/2025, 2:00:00 AM", "endTime": "3/1/2025, 2:59:59 AM" },
      { "totalActivity": 0, "startTime": "3/1/2025, 3:00:00 AM", "endTime": "3/1/2025, 3:59:59 AM" },
      { "totalActivity": 1, "startTime": "3/1/2025, 4:00:00 AM", "endTime": "3/1/2025, 4:59:59 AM" },
      { "totalActivity": 59, "startTime": "3/1/2025, 5:00:00 AM", "endTime": "3/1/2025, 5:59:59 AM" },
      { "totalActivity": 35, "startTime": "3/1/2025, 6:00:00 AM", "endTime": "3/1/2025, 6:59:59 AM" },
      { "totalActivity": 50, "startTime": "3/1/2025, 7:00:00 AM", "endTime": "3/1/2025, 7:59:59 AM" },
      { "totalActivity": 5, "startTime": "3/1/2025, 8:00:00 AM", "endTime": "3/1/2025, 8:59:59 AM" },
      { "totalActivity": 20, "startTime": "3/1/2025, 9:00:00 AM", "endTime": "3/1/2025, 9:59:59 AM" },
      { "totalActivity": 70, "startTime": "3/1/2025, 10:00:00 AM", "endTime": "3/1/2025, 10:59:59 AM" },
      { "totalActivity": 50, "startTime": "3/1/2025, 11:00:00 AM", "endTime": "3/1/2025, 11:59:59 AM" },
      { "totalActivity": 8, "startTime": "3/1/2025, 12:00:00 PM", "endTime": "3/1/2025, 12:59:59 PM" },
      { "totalActivity": 33, "startTime": "3/1/2025, 1:00:00 PM", "endTime": "3/1/2025, 1:59:59 PM" },
      { "totalActivity": 7, "startTime": "3/1/2025, 2:00:00 PM", "endTime": "3/1/2025, 2:59:59 PM" },
      { "totalActivity": 5, "startTime": "3/1/2025, 3:00:00 PM", "endTime": "3/1/2025, 3:59:59 PM" },
      { "totalActivity": 60, "startTime": "3/1/2025, 4:00:00 PM", "endTime": "3/1/2025, 4:59:59 PM" },
      { "totalActivity": 20, "startTime": "3/1/2025, 5:00:00 PM", "endTime": "3/1/2025, 5:59:59 PM" },
      { "totalActivity": 85, "startTime": "3/1/2025, 6:00:00 PM", "endTime": "3/1/2025, 6:59:59 PM" },
      { "totalActivity": 50, "startTime": "3/1/2025, 7:00:00 PM", "endTime": "3/1/2025, 7:59:59 PM" },
      { "totalActivity": 30, "startTime": "3/1/2025, 8:00:00 PM", "endTime": "3/1/2025, 8:59:59 PM" },
      { "totalActivity": 95, "startTime": "3/1/2025, 9:00:00 PM", "endTime": "3/1/2025, 9:59:59 PM" },
      { "totalActivity": 10, "startTime": "3/1/2025, 10:00:00 PM", "endTime": "3/1/2025, 10:59:59 PM" },
      { "totalActivity": 7, "startTime": "3/1/2025, 11:00:00 PM", "endTime": "3/1/2025, 11:59:59 PM" }
    ]
  };

  // console.log(data);

  // const chartSeries = pieChartData?.map(item => item?.totalActivity);
  // const chartLabels = pieChartData?.map(item => {
  //   const chartSeries = data?.result?.map(item => item?.totalActivity);
  //   const chartLabels = data?.result?.map(item => {
  //     const startTime = new Date(item?.startTime);
  //     const endTime = new Date(item?.endTime);

  //     const formattedStartTime = startTime?.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
  //     const formattedEndTime = endTime?.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });

  //     return `${formattedStartTime} To ${formattedEndTime}`;
  //   });

  // const chartOptions = {
  //   labels: chartLabels,
  //   colors: [
  //     "#FF5733", "#33FF57", "#3357FF", "#FF33A1", "#A133FF", "#33FFF6", "#FFD433", "#FF8C33",
  //     "#8CFF33", "#33FF8C", "#338CFF", "#8C33FF", "#FF338C", "#DFFF33", "#FF3333", "#33FFD4",
  //     "#D433FF", "#A1FF33", "#FFAA33", "#33A1FF", "#FF6F33", "#6FFF33", "#33FF6F", "#FF336F"
  //   ],
  //   legend: { show: false }
  // };

  // const chartSeries = new Array(data?.result?.length).fill(1);  

  // const chartSeries = pieChartData?.map(item => item?.totalActivity);
  // const chartSeries = data?.result?.map(item => item?.totalActivity);

  // // const chartLabels = pieChartData?.map(item => {  
  // const chartLabels = data?.result?.map(item => {  
  //   const startTime = new Date(item.startTime);
  //   const endTime = new Date(item.endTime);

  //   return `${startTime?.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })} 
  //   To 
  //   ${endTime?.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })}`;
  // });  

  // // const chartColors = pieChartData?.map(item => {
  // const chartColors = data?.result?.map(item => {
  //   return item.totalActivity === 0 ? "#FF0000" :  
  //          item.totalActivity >= 1 && item.totalActivity <= 10 ? "#FFA500" : 
  //          item.totalActivity > 10 && item.totalActivity <= 50 ? "#FFFF00" :
  //          "#008000"; 
  // });

  // console.log("chartColors:", chartColors); 

  // const chartOptions = {
  //   labels: chartLabels,
  //   colors: chartColors,
  //   legend: { show: false }
  // };

  const pieChartData1 = pieChartData?.length;
  // const chartSeries = Array(pieChartData1)?.fill(100 / 3);
  //  const chartSeries = [30,70];

  const [chartSeries, setChartSeries] = useState([0, 100]);



  const getColor = (activity) => {
    // console.log("activity", activity);
    if (activity === 0) {
      return "#C0C0C0";  // Grey
    }
    if (activity > 0 && activity < 10) {
      return "#FFA500";  // Orange
    }
    if (activity >= 10 && activity <= 50) {
      return "#B7950B";  // Yellow
    }
    if (activity > 50) {
      return "#2ECC71";  // Green
    }

    return "";
  };

  // const activityMap = new Map(pieChartData.map(item => {
  //   const startHour = new Date(item.startTime)?.getHours(); 
  //   return [startHour, item.totalActivity]; 
  // }));

  // const chartLabels = pieChartData?.map(({ startTime, endTime, totalActivity }) => {

  //   const formatTime = (timeString) => {
  //     const date = new Date(timeString);
  //     return date?.toLocaleString("en-US", {
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       hour12: true,
  //     });
  //   };

  //   return `${formatTime(startTime)} To ${formatTime(endTime)} | Activity: ${totalActivity}`;
  // });
  const chartLabels = ["placement"]

  // const chartColors = pieChartData?.map(item => getColor(item?.totalActivity));
  const chartColors = ["#2ECC71", "#C0C0C0"]

  const chartOptions = {
    chart: {
      type: "pie"
    },
    labels: chartLabels,
    colors: chartColors,
    // legend: { show: false },  
    legend: {
      show: false,
      // position: "bottom", 
      // horizontalAlign: "center", 
    },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        expandOnClick: true,
        // donut: { size: "20%" }
        customScale: 0.8,

      }
    },
    tooltip: {
      enabled: true,
      y: {
        formatter(value, { dataPointIndex }) {
          const { startTime, endTime, totalActivity } = pieChartData[dataPointIndex];

          const formatTime = (timeString) => {
            const date = new Date(timeString);
            const hours = date?.getHours();
            const minutes = date?.getMinutes()?.toString()?.padStart(2, "0");
            const period = hours < 12 ? "AM" : "PM";
            const formattedHour = hours % 12 === 0 ? 12 : hours % 12;
            return null;
            // return `${formattedHour}:${minutes} ${period}`;
          };

          // return `${formatTime(startTime)} - ${formatTime(endTime)}\nActivity: ${totalActivity}`;
          return null;
        }
      }
    }
  };

  const [ValuesDown, setValuesDown] = useState({

    fromDate: "",
    tillDate: "",

  });

  const handleDateChangeDown = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setValuesDown((prevRec) => ({
      ...prevRec,
      [field]: formattedDate
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };

  const [openDown, setOpenDown] = useState(false);
  const [down, setDown] = useState()

  const handleOpenDown = () => {
    // setDown(data)
    setOpenDown(true)
  }
  const handleCloseDown = () => setOpenDown(false);

  // const handleExport = (tableId, fileName) => {
  //   const table = document.getElementById(tableId);

  //   console.log("table xlsx data", table)
  //   const wb = XLSX.utils.table_to_book(table);
  //   XLSX.writeFile(wb, fileName);
  // };

  // const handleExport = (tableId, fileName) => {
  //   TableToExcel.convert(document.getElementById(tableId), {
  //     name: fileName,
  //     sheet: {
  //       name: "Sheet 1"
  //     }
  //   }); 
  // };

  const handleExport = async (tableId, fileName) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      let columns = [];

      if (tableId === "recTable") {
        columns = [
          { header: "Name", key: "name", width: 35 },
          { header: "Prospects", key: "prospects", width: 20 },
          { header: "Submissions", key: "submission", width: 20 },
          { header: "Unqualified", key: "unqualified", width: 20 },
          { header: "Interviews", key: "interview", width: 20 },
          { header: "Placements", key: "placements", width: 20 },
          { header: "Backouts", key: "backout", width: 20 },
        ];
      } else if (tableId === "salTable") {
        columns = [
          { header: "Name", key: "name", width: 35 },
          { header: "Prospects", key: "new", width: 20 },
          { header: "Pipeline", key: "pipeline", width: 20 },
          { header: "Meetings", key: "meeting", width: 20 },
          { header: "Converted", key: "converted", width: 20 },
          { header: "Passive", key: "passive", width: 20 },
        ];
      } else if (tableId === "clientTable") {
        columns = [
          { header: "Name", key: "name", width: 35 },
          { header: "Submissions", key: "submittedCount", width: 20 },
          { header: "Unqualified", key: "Unqualified", width: 20 },
          { header: "Interviews", key: "interviewCount", width: 20 },
          { header: "Placements", key: "placementCount", width: 20 },
          { header: "Backouts", key: "backoutCount", width: 20 },
        ];
      } else if (tableId === "benchTable") {
        columns = [
          { header: "Name", key: "name", width: 35 },
          { header: "Prospects", key: "prospects", width: 20 },
          { header: "Submissions", key: "submission", width: 20 },
          { header: "Unqualified", key: "unqualified", width: 20 },
          { header: "Interviews", key: "interview", width: 20 },
          { header: "Placements", key: "placements", width: 20 },
          { header: "Backouts", key: "backout", width: 20 },
        ];

      } else if (tableId === "placementTable") {
        columns = [
          { header: "Name", key: "name", width: 30 },
          { header: "Project", key: "projects", width: 25 },
          { header: "Billable Hours", key: "billableHours", width: 20 },
          { header: "Pay Rate", key: "payRate", width: 15 },
          { header: "Bill Rate", key: "billRate", width: 15 },
          { header: "Profit", key: "profit", width: 15 },
          { header: "Amount", key: "amount", width: 20 },
          { header: "Expenses", key: "expenses", width: 15 },
          { header: "Net Profit", key: "netProfit", width: 18 },
        ];
      }

      worksheet.columns = columns;

      let dataToAdd = [];
      if (tableId === "recTable") {
        dataToAdd = tableByDate;
      } else if (tableId === "salTable") {
        dataToAdd = ApiByCond ? salesxlsx : salesxlsx1;
      } else if (tableId === "clientTable") {
        dataToAdd = tableByDateClient;
      } else if (tableId === "benchTable") {
        dataToAdd = tableByDate2;
      } else if (tableId === "placementTable") {
        dataToAdd = tableDataPlacement;
      }

      // dataToAdd.forEach((row) => {
      //   worksheet.addRow(row);
      // });

      const roles = {
        recruiterHead: "Recruitment Head",
        recruiterManager: "Recruitment Manager",
        recruiterTeamLead: "Recruitment Lead",
        recruiter: "Technical Recruiter",
        recruiterTrainee: "Recruitment Trainee",
        salesHead: "Sales Head",
        salesManager: "Sales Manager",
        salesTeamLead: "Sales Team Lead",
        salesExecutive: "Sales Executive",
        salesTrainee: "Sales Trainee",
        benchSalesHead: "Bench Sales Head",
        benchSalesManager: "Bench Sales Manager",
        benchSalesTeamLead: "Bench Sales Lead",
        benchSalesExecutive: "Bench Sales Executive",
        admin: "Admin",
        superadmin: "Super Admin",
      }

      dataToAdd.forEach((row) => {
        const formattedName = row.name
          .split(" ")
          .map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
          .join(" ");

        let formattedRole = "";
        if (row.role) {
          formattedRole = roles[row?.role] || row?.role?.replace(/([A-Z])/g, " $&");
        }

        worksheet.addRow({
          ...row,
          name: formattedRole ? `${formattedName} - ${formattedRole}` : formattedName,
        });
      });

      // dataToAdd.forEach((row) => {
      //   worksheet.addRow({
      //     ...row,
      //     name: `${row.name} - ${row.role ? row.role : ''}`,
      //   });
      // });

      let totalRow = {};

      if (tableId === "recTable") {
        totalRow = {
          name: "Total",
          prospects: totall?.totalprospectsCounnts,
          submission: totall?.totalCandidateSubmission,
          unqualified: totall?.totalCandidateUnqualified,
          interview: totall?.totalCandidateInterview,
          placements: totall?.totalCandidatePlacements,
          backout: totall?.totalCandidateBackout,
        };

      } else if (tableId === "salTable") {
        // console.log("salesxlsxT1", salesxlsxT1)
        totalRow = {
          name: "Total",
          new: (ApiByCond ? salesxlsxT : salesxlsxT1)?.new,
          pipeline: (ApiByCond ? salesxlsxT : salesxlsxT1)?.pipeline,
          meeting: (ApiByCond ? salesxlsxT : salesxlsxT1)?.meeting,
          converted: (ApiByCond ? salesxlsxT : salesxlsxT1)?.converted,
          passive: (ApiByCond ? salesxlsxT : salesxlsxT1)?.passive,
        };

      } else if (tableId === "clientTable") {
        // console.log(" tableByDateClientTotal?.totalSubmittedCount,",  tableByDateClientTotal?.totalSubmittedCount,)
        totalRow = {
          name: "Total",
          submittedCount: tableByDateClientTotal?.totalSubmittedCount,
          Unqualified: tableByDateClientTotal?.totalUnqualifiedCount,
          interviewCount: tableByDateClientTotal?.totalInterviewCount,
          placementCount: tableByDateClientTotal?.totalPlacementCount,
          backoutCount: tableByDateClientTotal?.totalBackoutCount,
        };

      } else if (tableId === "benchTable") {
        totalRow = {
          name: "Total",
          prospects: totall2?.totalprospectsCounnts,
          submission: totall2?.totalCandidateSubmission,
          unqualified: totall2?.totalCandidateUnqualified,
          interview: totall2?.totalCandidateInterview,
          placements: totall2?.totalCandidatePlacements,
          backout: totall2?.totalCandidateBackout,
        };
      } else if (tableId === "placementTable") {
        totalRow = {
          name: "Total",
          projects: placementGrandTotal.projects,
          billableHours: placementGrandTotal.billableHours,
          payRate: placementGrandTotal.payRate,
          billRate: placementGrandTotal.billRate,
          profit: placementGrandTotal.profit,
          amount: placementGrandTotal.amount,
          expenses: placementGrandTotal.expenses,
          netProfit: placementGrandTotal.netProfit,
        };
      }
      const newRow = worksheet.addRow(totalRow);

      newRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF0000FF" },
        };

        cell.font = { color: { argb: "FFFFFFFF" } };

        if (colNumber === 1 && cell.value !== "Total") {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        }
      });

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
      headerRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0000FF" },
      };
      headerRow.alignment = { horizontal: "left" };

      worksheet.eachRow((row, rowIndex) => {
        if (rowIndex > 1) {
          row.eachCell((cell, colNumber) => {
            if (colNumber === 1 && row.getCell(colNumber).value !== "Total") {
              cell.font = { bold: true };
            }
            cell.alignment = { horizontal: "left" };
          });
        }
      });

      // console.log("worksheet======>>>>>>>", worksheet)
      // console.log("workbook======>>>>>>>", workbook)

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, `${fileName}.xlsx`);
      // setSalesxlsx([])
      //       setSalesxlsxT([])
    } catch (error) {
      // console.error("Error generating Excel file:", error);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    return d.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const [placementPercentage, setplacementPercentage] = useState()
  const [placementbar, setPlacementbaar] = useState([]);
  const [placementPieChart, setplacementPieChart] = useState();
  const [tableDataPlacement, settableDataPlacement] = useState([]);
  const [fromDate, tillDate] = useState();
  const [fromDate1, tillDate1] = useState();

  const [dateValue, setDateValue] = useState({
    fromMonth: dayjs().format("YYYY-MM"),
    tillMonth: dayjs().format("YYYY-MM"),
  });

  console.log("date===>", dateValue)

  useEffect(() => {
    placement();
  }, [])
  const placement = () => {
    const token1 = localStorage.getItem('token');

    const roleBody = Role?.includes("recruitor") ? "recruitor" : "bench"
    const body = {
      "unit": "month",
      "amount": 1,
      "placementFrom": roleBody
    }
    Api('common/placementPercentage', 'POST', body, token1).then((response) => {
      if (response.status === 200) {
        console.log("HELLO ", response);
        setplacementPercentage(response.data)
      } else {
        // toast.warn(Response.error + '!');
      }
    }).catch((error) => {
      // toast.error('Failed to fetch clients! ' + error.message);
    });
  };




  function getPlacementBar(val, id, tp) {
    const body = {
      "unit": tp || rec.timePeriod,
      //   "dataOf": "All",
      "placementFrom": val || rec.placement,




      //  "userId": id || rec.userId || individual?._id, 
      // "fromDate": '',
      // "tillDate": ''
    }
    Api(`common/placementBarGraph`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // setRbarBench(response.data.result)
          console.log("hello  syntex ===>>", response)
          setPlacementbaar(response.data.data)
          if (response.data.code === 200) {
            // setSbar(response.data.inRangedTotalForAllUsers);
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  function placementPieChart1(val, id, tp) {
    const body = {
      "unit": tp || rec.timePeriod,
      "placementFrom": val || rec.placement,
    };

    Api("common/placementPieChart", "POST", body, token)
      .then((response) => {
        console.log("responce===>>", response.data.result.totalPlacementCount);

        console.log(response)
        if (response.status === 200 && response.data.status === 200) {
          //  setPieChartData(response.data.result);
          //             tillDate(response.data.dateObject.fromDate)
          //             tillDate1(response.data.dateObject.tillDate)

          // setChartSeries([
          //   response.data.result.totalPlacementCount,
          //   100 -  response.data.result.totalPlacementCount
          // ]);

          setPlacementPieChartData(response.data.result)
          setPlacementPieChartDate(response.data)

        } else {
          toast.warn(response?.data?.message || "Something went wrong!");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "API Error!");
      });
  }

  function placementTableData(fromDate, tillDate, tp) {
    const body = {
      // "dataOf": "all",
      // "userId": "",   
      // "dataOf": t || rec.isTeam,
      // "userId": id || rec.userId || individual?._id,


      "fromMonth": fromDate || dateValue.fromMonth || '',
      "tillMonth": tillDate || dateValue.tillMonth || '',
      "placementFrom": tp || rec.placement,

    };
    Api(`common/placementTableData`, 'POST', body, token)
      .then((response) => {
        console.log("hyeeee======>>>>", response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            settableDataPlacement(response.data.tableData);
            setPlacementGrandTotal(response.data?.grandTotal)
            console.log("hello nobilliotechnologi in what case of lenagugae in morinhdbc ==>", response.data.tableData)
          } else {
            console.log("")
            // toast.warn(response.data.message + '!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err + '!');
      });



  }


  // const scrollRef = useRef(null);
  //   const tabRefs = useRef({});

  //   useEffect(() => {
  //     if (tabRefs.current[tab]) {
  //       tabRefs.current[tab].scrollIntoView({
  //         behavior: 'smooth',
  //         inline: 'center',
  //         block: 'nearest',
  //       });
  //     }
  //   }, [tab]);

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title> Dashboard | Foxearch</title>
      </Helmet>

      {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '89%', marginLeft:'17px', marginBottom:'20px'}}>
      <FormControl variant="outlined" size="small">
        <InputLabel id="dropdown-label">Dropdown</InputLabel>
        <Select
          labelId="dropdown-label"
          // value={dropdownValue}
          // onChange={handleDropdownChange}
          label="Dropdown"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </FormControl>
    </Box> */}


      {/* <ClickAwayListener> */}
      <div>
        <div className='mob_search'>
          <FormControl size="small" sx={{
            width: '100%',
            // borderRadius: '10px',
            border: "none",
            marginLeft: '20px',
            backgroundColor: "white",
            // border: '1px solid "#3C6BA5"', 
            // border: '1px solid #1E74B3',
            overflow: 'hidden',
            marginTop: -18,
          }}>
            <Select
              value={selectedDropdownValue}
              onChange={handleChangeDrop}
              size="small"
              className='dash_sr'
              sx={{
                borderRadius: '10px',
                border: '1px solid #1E74B3',
                '&:focus-visible': {
                  borderRadius: '10px',
                  border: '1px solid #1E74B3',
                },
              }}

              MenuProps={{
                disableScrollLock: true,
              }}
            >
              <MenuItem value='recruitment' disabled={!ShowDataRec}>Recruitment</MenuItem>
              <MenuItem value='sales' disabled={!ShowDataSal}>Sales</MenuItem>
              {/* <MenuItem value='sales' >Sales</MenuItem> */}
              {/* <MenuItem value='item orders' disabled>Job Order</MenuItem> */}
              <MenuItem value='bench'>Bench Sales</MenuItem>
              <MenuItem value='clients' disabled={clientAccess === "noaccess"}>Clients</MenuItem>
              <MenuItem value='placement'>Placement</MenuItem>
              {/* <MenuItem value='Bug Reports' disabled>Placement</MenuItem> */}
            </Select>
          </FormControl>

          <Button color="custom" variant="contained" size="small"
            sx={{ ml: 1.6, mt: -18 }}
            onClick={Funcc}>
            Search
          </Button>
        </div>
      </div>


















      {/* </ClickAwayListener> */}
      <Container maxWidth="xl">
        <Typography variant="h5" sx={{ mb: 0.1, color: "#3C6BA5", mt: '-5px' }} >
          {/* Hi, Welcome back {localStorage.getItem('username')} */}
          Performance Pulse
        </Typography>

        <Box sx={{ display: { xs: "none", sm: "flex" }, justifyContent: "flex-end", mb: 1 }}>
          <Button onClick={scrollLeft}>◀</Button>
          <Button onClick={scrollRight}>▶</Button>
        </Box>

        <Box
          ref={scrollRef}
          sx={{
            mb: 2,
            // overflowX: "auto", 
            // overflowY: "hidden",
            overflowX: { xs: "hidden", sm: "auto" },
            overflowY: "hidden",
            whiteSpace: "nowrap",
            "&::-webkit-scrollbar": {
              height: 6,
            },
            // "&::-webkit-scrollbar-thumb": {
            //   backgroundColor: "#3C6BA5",
            //   borderRadius: 10,
            // },
          }}
        >
          <Grid container spacing={3}
            // wrap="nowrap"
            sx={{
              flexWrap: { xs: "wrap", sm: "nowrap" },
            }}
          >
            {/* <Grid item xs={12} sm={6} md={3} 
          // onClick={() => handleTab('recruitment')}
          onClick={Role === ('recruiterHead' || "recruiterManager" || "recruiterTeamLead" || "recruiter") ? () => handleTab('recruitment') : null}
          >
            <AppWidgetSummary
              selected={tab === 'recruitment' && Role === ('recruiterHead' || "recruiterManager" || "recruiterTeamLead" || "recruiter")}
              // sx={style}
              sx={tab === 'recruitment' && Role === ('recruiterHead' || "recruiterManager" || "recruiterTeamLead" || "recruiter") ? { ...style, border: '3px solid #3C6BA5' } : style}
              title="Recruitment" total={per.totalPlacementsCounts} percentage={per.RecruitementPercenatge} perSign={per.RecruitementPercenatgeSign}
            />
          </Grid> */}

            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              // md={2.4}
              sx={{ minWidth: { xs: "100%", sm: 320 } }}
              onClick={(Role === 'recruiterHead' || Role === 'recruiterTrainee' || Role === 'recruiterManager' ||
                Role === 'recruiterTeamLead' || Role === 'recruiter' ||
                Role === 'admin' || localStorage.getItem("typeUser") === "individual" &&
                localStorage.getItem("role") === "admin") ? () => handleTab('recruitment') : null}
            >
              <AppWidgetSummary
                selected={tab === 'recruitment' && (Role === 'recruiterTrainee' || Role === 'recruiterHead' ||
                  Role === 'recruiterManager' || Role === 'recruiterTeamLead' || Role === 'recruiter' || Role === 'admin'
                  || localStorage.getItem("typeUser") === "individual" && localStorage.getItem("role") === "admin")}
                sx={tab === 'recruitment' && (Role === 'recruiterTrainee' || Role === 'recruiterHead' ||
                  Role === 'recruiterManager' || Role === 'recruiterTeamLead' || Role === 'recruiter' ||
                  Role === 'admin' || localStorage.getItem("typeUser") === "individual" && localStorage.getItem("role") === "admin") ? { ...style, border: '3px solid #3C6BA5' } : style}
                title="Recruitment"
                disabled={userType === 'benchSales'}
                total={per.totalPlacementsCounts}
                percentage={per.RecruitementPercenatge}
                perSign={per.RecruitementPercenatgeSign}
              />
              {/* <AppWidgetSummary
              selected={ShowDataRec}
              sx={ShowDataRec ? { ...style, border: '3px solid #3C6BA5' } : style}
              title="Recruitment"
              total={ShowDataRec ? per.totalPlacementsCounts : 0}
              percentage={ShowDataRec ? per.RecruitementPercenatge : 0}
              perSign={per.RecruitementPercenatgeSign}
            />  */}
            </Grid>

            {/* <Grid item xs={12} sm={6} md={3} onClick={() => handleTab('sales')}>
            <AppWidgetSummary
              selected={tab === 'sales'}
              // sx={style}
              sx={tab === 'sales' ? { ...style, border: '3px solid #3C6BA5' } : style}
              title="Sales" total={per.totalClientsCounts} 
              percentage={per.SalesPercenatge} perSign={per.SalesPercenatgeSign} 
              color="info" icon={'ant-design:apple-filled'} />
          </Grid> */}

            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              sx={{ minWidth: { xs: "100%", sm: 320 } }}
              onClick={(Role === 'salesHead' || Role === 'salesTrainee' || Role === 'salesManager' ||
                Role === 'salesTeamLead' || Role === 'salesExecutive' || Role === 'admin' ||
                localStorage.getItem("typeUser") === "individual" && localStorage.getItem("role") === "admin") ? () => handleTab('sales') : null}
            >
              {/* <AppWidgetSummary 
              selected={ShowDataSal}
              sx={ShowDataSal ? { ...style, border: '3px solid #3C6BA5' } : style}
              title="Sales"
              total={ShowDataSal ? per.totalClientsCounts : 0}
              percentage={ShowDataSal ? per.SalesPercenatge : 0}
              perSign={per.SalesPercenatgeSign}
              color="info"
              icon={'ant-design:apple-filled'}
            /> */}
              <AppWidgetSummary
                selected={tab === 'sales'}
                // sx={style}
                disabled={userType === 'benchSales'}
                sx={tab === 'sales' ? { ...style, border: '3px solid #3C6BA5' } : style}
                title="Sales" total={per.totalClientsCounts}
                percentage={per.SalesPercenatge} perSign={per.SalesPercenatgeSign}
                color="info" icon={'ant-design:apple-filled'} />
            </Grid>

            <Grid item xs={12} sm={6}
              md={3}
              sx={{ minWidth: { xs: "100%", sm: 320 } }}
              onClick={() => handleTab('bench')}>
              {/* <Grid item xs={12} sm={6} md={3}> */}
              <AppWidgetSummary
                selected={tab === 'bench'}
                // disabled={clientAccess === "noaccess"}
                // sx={style}
                sx={tab === 'bench' ? { ...style, border: '3px solid #3C6BA5' } : style}
                // title="Job Order" total={0} percentage={0} color="warning" icon={'ant-design:windows-filled'} />
                title="Bench Sales" total={benchPer.totalPlacementsCounts}
                percentage={benchPer.RecruitementPercenatge}
                perSign={benchPer.RecruitementPercenatgeSign}
                color="warning" icon={'ant-design:windows-filled'} />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={3} onClick={clientAccess === "noaccess" ? null : () => handleTab('re')}>
            <AppWidgetSummary
              selected={tab === 're'}
              disabled={clientAccess === "noaccess" || userType === 'benchSales'}
              sx={tab === 're' ? { ...style, border: '3px solid #3C6BA5' } : style}
              title="Clients" 
              total={per.totalActiveCount} percentage={per.clientPercentage}
              perSign={per.ClientPercentageSign}
              color="warning" icon={'ant-design:windows-filled'} />
          </Grid> */}

            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              onClick={clientAccess === "noaccess" || userType === 'benchSales' ? null : () => handleTab('re')}
              sx={{
                pointerEvents: clientAccess === "noaccess" || userType === 'benchSales' ? 'none' : 'auto',
                opacity: clientAccess === "noaccess" || userType === 'benchSales' ? 1 : 1,
                minWidth: { xs: "100%", sm: 320 }
              }}
            >
              <AppWidgetSummary
                selected={tab === 're'}
                sx={tab === 're' ? { ...style, border: '3px solid #3C6BA5' } : style}
                title="Clients"
                total={per.totalActiveCount}
                percentage={per.clientPercentage}
                perSign={per.ClientPercentageSign}
                color="warning"
                icon={'ant-design:windows-filled'}
              />
            </Grid>



            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              onClick={() => handleTab('placement')}

              sx={{
                pointerEvents: clientAccess === "noaccess" || userType === 'benchSales' ? 'none' : 'auto',
                opacity: clientAccess === "noaccess" || userType === 'benchSales' ? 1 : 1,
                minWidth: { xs: "100%", sm: 320 }
              }}
            >
              <AppWidgetSummary
                selected={tab === 'placement'}
                sx={tab === 'placement' ? { ...style, border: '3px solid #3C6BA5' } : style}
                title="Placement"
                total={placementPercentage?.totalPlacementsCounts}
                percentage={placementPercentage?.PlacementPercentage}
                perSign={placementPercentage?.PlacementPercentageSign}
                color="warning"
                icon={'ant-design:windows-filled'}
              />
            </Grid>




            {/* <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              sx={style}
              title="Placement" total={0} percentage={0} color="error" icon={'ant-design:bug-filled'} />
          </Grid> */}




          </Grid>
        </Box>

        <Grid container spacing={3}>
          {tab === "placement" && (
            <Grid item xs={12} md={12} lg={12}>

              <Stack sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 2, boxShadow: 2, gap: 1, flexDirection: 'row', border: '1px solid #3C6BA5' }}>
                <FormControl fullWidth size='small' >
                  <InputLabel id="demo-simple-select-label">Placement</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rec.placement}
                    label="Duration"
                    onChange={(e) => { setRec({ ...rec, placement: e.target.value }); getAll(e.target.value, "", "") }}
                  >
                    <MenuItem value={'recruitor'}>Recruitment</MenuItem>
                    <MenuItem value={'bench'}>Bench</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth size='small' >
                  <InputLabel id="demo-simple-select-label">Duration</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rec.timePeriod}
                    label="Duration"
                    onChange={(e) => { setRec({ ...rec, timePeriod: e.target.value }); getAll("", "", e.target.value) }}
                  >
                    <MenuItem value={'day'}>Day</MenuItem>
                    <MenuItem value={'week'}>Week</MenuItem>
                    <MenuItem value={'month'}>Month</MenuItem>
                    <MenuItem value={'year'}>Year</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Grid>
          )}






          {
            tab !== "placement" && (<Grid item xs={12} md={12} lg={12}>
              <Stack sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 2, boxShadow: 2, gap: 1, flexDirection: 'row', border: '1px solid #3C6BA5' }}>




                <FormControl fullWidth size='small' >
                  <InputLabel id="demo-simple-select-label">Duration</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rec.timePeriod}
                    label="Duration"
                    onChange={(e) => { setRec({ ...rec, timePeriod: e.target.value }); getAll("", "", e.target.value) }}
                  >
                    <MenuItem value={'day'}>Day</MenuItem>
                    <MenuItem value={'week'}>Week</MenuItem>
                    <MenuItem value={'month'}>Month</MenuItem>
                    <MenuItem value={'year'}>Year</MenuItem>
                  </Select>
                </FormControl>
                {/* <FormControl fullWidth size='small' >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From"
                    value={rec.from}
                    slotProps={{ textField: { size: 'small' } }}
                    onChange={(e) => setRec({ ...rec, from: e })}

                  />
                </LocalizationProvider>
              </FormControl>
              <FormControl fullWidth size='small' >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Till"
                    value={rec.till}
                    slotProps={{ textField: { size: 'small' } }}
                    onChange={(e) => setRec({ ...rec, till: e })}

                  />
                </LocalizationProvider>
              </FormControl> */}
                <FormControl fullWidth size='small' >
                  <InputLabel>
                    {tab !== "re" && tab !== "bench" ? "Individual / Team" : "Individual"}</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    value={rec.isTeam}
                    label={tab !== "re" && tab !== "bench" ? "Individual / Team" : "Individual"}
                    onChange={(e) => {
                      setRec({ ...rec, isTeam: e.target.value });
                      if (e.target.value === 'all') {
                        setApiByCond(false)
                        recTableByDate()

                        allTableByDate()
                        clientTableByDate("all", '')
                        benchTableByDate("all", '')
                        getAll(e.target.value)
                      } else if (e.target.value === 'individual') {
                        setApiByCond(true)
                        handleUser()
                        recTableByDate()
                        salTableByDate()
                      } else if (e.target.value === 'team') {
                        setApiByCond(true)
                      }
                    }}
                  >
                    {localStorage.getItem("typeUser") === "individual" ? (
                      <MenuItem value={'individual'}>Individual</MenuItem>
                    ) : [
                      <MenuItem key="all" value={'all'}>All</MenuItem>,
                      <MenuItem key="individual" value={'individual'}>Individual</MenuItem>,
                      (tab !== "re" && tab !== "bench") && (
                        <MenuItem key="team" value={'team'}>Team</MenuItem>
                      )
                    ]}


                  </Select>
                </FormControl>




                {rec.isTeam === 'team' && (
                  tab === 'recruitment' ? (
                    <FormControl fullWidth size='small' >
                      <InputLabel id="demo-simple-select-label">Team</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={rec.tempRole}
                        label="Team"
                        onChange={(e) => { setRec({ ...rec, tempRole: e.target.value }); handleRole(e.target.value); recTableByDate(); salTableByDate() }}
                      >

                        <MenuItem value={'recruiterHead'}>RH</MenuItem>
                        <MenuItem value={'recruiterManager'}>RM</MenuItem>
                        <MenuItem value={'recruiterTeamLead'}>RL</MenuItem>

                      </Select>
                    </FormControl>
                  ) : (
                    <FormControl fullWidth size='small' >
                      <InputLabel id="demo-simple-select-label">Team</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={rec.tempRole}
                        label="Team"
                        onChange={(e) => { setRec({ ...rec, tempRole: e.target.value }); handleRole(e.target.value) }}
                      >
                        <MenuItem value={'salesHead'}>SH</MenuItem>
                        <MenuItem value={'salesManager'}>SM</MenuItem>
                        <MenuItem value={'salesTeamLead'}>SL</MenuItem>

                      </Select>
                    </FormControl>
                  )

                )}
                {(rec.isTeam !== 'all' && localStorage.getItem("typeUser") !== "individual") && (
                  <FormControl fullWidth size='small' >
                    <InputLabel id="demo-simple-select-label">Users</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={rec.userId}
                      disabled={disrole === false || localStorage.getItem("dash") === "dash"}
                      // value={tab !== "re" ? rec.userId : rec.cid}
                      value={
                        localStorage.getItem("dash") === "dash"
                          ? individual?._id
                          : tab !== "re"
                            ? rec.userId
                            : rec.cid || individual?._id
                      }

                      label="Users"
                      // onChange={(e) => {
                      //   setRec({ ...rec, userId: e.target.value });
                      //   getAll(rec.isTeam, e.target.value)
                      //   recTableByDate()
                      //   salTableByDate()
                      // }} 
                      onChange={handleChange}
                    >
                      {tab === "re" ? (
                        clientList?.map((item) => (
                          <MenuItem
                            key={item.cid}
                            value={item.cid}
                            style={{ color: item.status !== "Active" ? "red" : "" }}
                          >
                            {item.name}: {item.clientCompanyId}
                          </MenuItem>
                        ))
                      ) : tab === "bench" ? (
                        benclientList.map((item) => (
                          <MenuItem key={item._id} value={item._id}>
                            {item.contactPersonName} : {item.USERID}
                          </MenuItem>
                        ))
                      ) : localStorage.getItem("dash") === "dash" ? (
                        <MenuItem key={individual._id} value={individual?._id}>
                          {individual?.contactPersonName} : {individual?.USERID}
                        </MenuItem>
                      ) : (
                        Users.map((item) => (
                          <MenuItem key={item._id} value={item._id}>
                            {item.contactPersonName} : {item.USERID}
                          </MenuItem>
                        ))
                      )}

                    </Select>
                  </FormControl>
                )}
              </Stack>
            </Grid>)
          }























          {tab === 'recruitment' && (
            <>
              <Grid item xs={12} md={6} lg={8}>
                <AppWebsiteVisits sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}
                  // title="Ration of Submissions, Interviews & Placements"
                  title="Submissions | Interviews | Placements"
                  // subheader="(+43%) than last year"
                  chartLabels={[...rbar?.map((item) => item.date.replace(/-/g, "/"))]}
                  chartData={[
                    {
                      name: 'Submissions',
                      type: 'column',
                      fill: 'solid',
                      color: '#B7950B',
                      data: [...rbar?.map((item) => item.submission)],
                    },
                    {
                      name: 'Interviews',
                      type: 'column',
                      // type: 'area',
                      color: '#F4D03F',
                      fill: 'solid',
                      data: [...rbar?.map((item) => item.interview)],
                    },
                    {
                      name: 'Placements',
                      type: 'column',
                      // type: 'line',
                      color: '#2ECC71',
                      fill: 'solid',
                      data: [...rbar?.map((item) => item.placements)],
                    },
                  ]}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4} >
                <AppCurrentVisits sx={{
                  border: '3px solid #3C6BA5', textAlign: 'center',
                  color: "#3C6BA5",
                  height: recRaddial?.dateObject ? "100%" : "100%",

                }}
                  title="Recruitment Status"

                  date={
                    recRaddial?.dateObject
                      ? `${new Date(recRaddial?.dateObject?.fromDate).toLocaleDateString('en-US', { timeZone: 'UTC' })} 
                        - ${new Date(recRaddial?.dateObject?.tillDate).toLocaleDateString('en-US', { timeZone: 'UTC' })}`
                      : ''
                  }
                  chartData={[
                    { label: 'Prospects', value: recRaddial?.totalprospectsCounnts || 0 },
                    { label: 'Submissions', value: recRaddial?.totalCandidateSubmission || 0 },
                    { label: 'Interviews', value: recRaddial?.totalCandidateInterview || 0 },
                    { label: 'Placements', value: recRaddial?.totalCandidatePlacements || 0 },
                    { label: 'Backouts', value: recRaddial?.totalCandidateBackout || 0 },
                  ]}
                  chartColors={[
                    theme.palette.secondary.main,
                    '#B7950B',
                    '#F4D03F',
                    '#2ECC71',
                    '#CB4335',

                  ]}
                  val={per.RecruitementPercenatge}
                  centerLabel="Placements"
                  centerValue={recRaddial?.totalCandidatePlacements}

                />


                {/* <ApexCharts
  style={{
    border: '3px solid #3C6BA5',
    textAlign: 'center',
    color: "#3C6BA5",
    height: '100%',
    borderRadius: "10px"
  }}
  options={chartData1.options}
  series={chartData1.series}
  type="line"
  height="88%"
/> */}

              </Grid>
              {/* <Grid item xs={12} md={12} lg={12}>
                <Stack sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 2, boxShadow: 2, gap: 1, flexDirection: 'row', border: '1px solid #3C6BA5' }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="From"
                        slotProps={{ textField: { size: 'small' } }}
                        value={valuee.fromDate ? dayjs(valuee.fromDate) : null}
                        // value={rec.fromDate ? dayjs(rec.fromDate) : (valuee.fromDate ? dayjs(valuee.fromDate) : null)}

                        onChange={(date) => handleDateChange(date, 'fromDate')}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Till"
                        slotProps={{ textField: { size: 'small' } }}
                        value={valuee.tillDate ? dayjs(valuee.tillDate) : null}
                        // value={rec.tillDate ? dayjs(rec.tillDate) : (valuee.tillDate ? dayjs(valuee.tillDate) : null)}

                        onChange={(date) => handleDateChange(date, 'tillDate')}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Stack>
              </Grid> */}
              <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: "11px", marginBottom: "-11px" }}>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  {/* <FormControl fullWidth size='small'>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      slotProps={{ textField: { size: 'small' } }}
      value={valuee.fromDate ? dayjs(valuee.fromDate) : null}
      onChange={(date) => handleDateChange(date, 'fromDate')}
      sx={{
        '& .css-1ql7g3c-MuiButtonBase-root-MuiIconButton-root': {
          color: '#fff !important',
        },
        '& .css-d58xje-MuiInputBase-input-MuiOutlinedInput-input': {
          color: '#fff !important',
        },
      }}
    />
  </LocalizationProvider>
</FormControl> */}

                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valuee.fromDate ? dayjs(valuee.fromDate) : null}
                        onChange={(date) => handleDateChange(date, 'fromDate')}
                        className="dash_dt"
                      />

                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Typography sx={{ marginTop: "6px", fontSize: "16px" }}>To</Typography>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }} >
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        // label="Till"
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valuee.tillDate ? dayjs(valuee.tillDate) : null}
                        onChange={(date) => handleDateChange(date, 'tillDate')}
                        className="dash_dt"
                      // renderInput={(props) => (
                      //   <TextField {...props} InputProps={{ className: 'bold-date' }} />
                      // )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                {/* <Button  color="custom" variant="contained" 
                // onClick={()=>handleOpenDown()}
                onClick={()=>handleExport('recTable', "recruiterExcelFile.xlsx")}
                sx={{ml:2}}
                >Export
                </Button> */}
                {/* <Grid item>
                  {rec.isTeam === 'all' && (
                <Button
        color="custom"
        variant="contained"
        size="small"
        sx={{ marginRight: '-25px', marginLeft: "15px" }}
      >
        {buttonLabel}
      </Button>
                  )}
  </Grid>
  <Grid item sx={{ml:5}}>

  <Switch 
  
  onClick={()=>toggleButtonLabel()} 
  inputProps={{ 'aria-label': 'controlled' }} />
             
  </Grid> */}
                <Grid item sx={{
                  ml: {
                    xs: '80%',
                    md: '93.5%'
                  },
                  display: 'flex', mt: -5
                }}>
                  {rec.isTeam === 'all' && (
                    <Typography color={'text.secondary'} sx={{ mt: 1 }}>Active</Typography>
                  )}
                  <Switch
                    checked={active === 'active'}
                    onClick={() => toggleButtonLabel()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ overflowX: 'auto', width: '98%', mt: 2.5, ml: 3 }}>
                <Grid item xs={24} md={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table id="recTable" sx={{ minWidth: 650, border: '3px solid #3C6BA5', borderRadius: "10px" }} aria-label="simple table">
                      <TableHead>
                        <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Name</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Prospects</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Engagements</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Submissions</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Clients Sub.</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Unqualified</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Interviews</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Placements</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Backouts</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tableByDate?.map((item, index) => (

                          <TableRow
                            key={index}
                            sx={[
                              { background: index % 2 === 0 ? 'text.background' : tablebg },
                              { '&:last-child td, &:last-child th': { border: 0 } },
                              { '&:hover': { boxShadow: 5 } },
                            ]}
                          >
                            <TableCell
                              sx={{
                                p: 1,
                                py: 0.5,
                                color: item?.status === "inactive" ? "red" : "",
                              }}
                            >
                              <span style={{ fontWeight: item.name ? "bold" : "normal" }}>
                                {item.name}
                              </span>
                              {" - "}
                              {item?.role === "recruiterHead"
                                ? "Recruitment Head"
                                : item?.role === "recruiterManager"
                                  ? "Recruitment Manager"
                                  : item?.role === "recruiterTeamLead"
                                    ? "Recruitment Lead"
                                    : item?.role === "recruiter"
                                      ? "Technical Recruiter"
                                      : item?.role === "recruiterTrainee"
                                        ? "Recruitment Trainee"
                                        : item?.role === "salesHead"
                                          ? "Sales Head"
                                          : item?.role === "salesManager"
                                            ? "Sales Manager"
                                            : item?.role === "salesTeamLead"
                                              ? "Sales Team Lead"
                                              : item?.role === "salesExecutive"
                                                ? "Sales Executive"
                                                : item?.role === "salesTrainee"
                                                  ? "Sales Trainee"
                                                  : item?.role === "benchSalesHead"
                                                    ? "Bench Sales Head"
                                                    : item?.role === "benchSalesManager"
                                                      ? "Bench Sales Manager"
                                                      : item?.role === "benchSalesTeamLead"
                                                        ? "Bench Sales Lead"
                                                        : item?.role === "benchSalesExecutive"
                                                          ? "Bench Sales Executive"
                                                          : item?.role === "admin"
                                                            ? "Admin"
                                                            : item?.role === "superadmin"
                                                              ? "Super Admin"
                                                              : item?.role?.replace(/([A-Z])/g, " $&") || "-"}
                            </TableCell>

                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.prospects}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.phoneCall}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.submission}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.clientSubmission}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.unqualified} (
                              {Number.isFinite((item.unqualified / item.submission) * 100)
                                ? ((item.unqualified / item.submission) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.interview} (
                              {Number.isFinite((item.interview / item.submission) * 100)
                                ? ((item.interview / item.submission) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.placements} (
                              {Number.isFinite((item.placements / item.submission) * 100)
                                ? ((item.placements / item.submission) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.backout} (
                              {Number.isFinite((item.backout / item.placements) * 100)
                                ? ((item.backout / item.placements) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>Total</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall.totalprospectsCounnts}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall.totalPhoneCalls}</TableCell>  
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall.totalCandidateSubmission}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall.totalClientSubmission}</TableCell>     
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall.totalCandidateUnqualified} (
                            {Number.isFinite((totall.totalCandidateUnqualified / totall.totalCandidateSubmission) * 100)
                              ? ((totall.totalCandidateUnqualified / totall.totalCandidateSubmission) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall.totalCandidateInterview} (
                            {Number.isFinite((totall.totalCandidateInterview / totall.totalCandidateSubmission) * 100)
                              ? ((totall.totalCandidateInterview / totall.totalCandidateSubmission) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall.totalCandidatePlacements} (
                            {Number.isFinite((totall.totalCandidatePlacements / totall.totalCandidateSubmission) * 100)
                              ? ((totall.totalCandidatePlacements / totall.totalCandidateSubmission) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall.totalCandidateBackout} (
                            {Number.isFinite((totall.totalCandidateBackout / totall.totalCandidatePlacements) * 100)
                              ? ((totall.totalCandidateBackout / totall.totalCandidatePlacements) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button color="custom" variant="contained"
                    onClick={() => handleExport('recTable', "recruiterExcelFile.xlsx")}
                    sx={{ mt: 1.8, mx: 'auto', display: 'block' }}
                  >Export
                  </Button>
                </Grid>
              </Box>
            </>
          )}
          {(tab === 'sales' && rec.isTeam === 'all') ? (
            <>
              <Grid item xs={12} md={6} lg={8}>
                <AppWebsiteVisits
                  sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}
                  title="Pipeline | Meetings | Converted"
                  chartLabels={sbar?.map(item => item.date.replace(/-/g, "/"))}
                  chartData={[
                    {
                      name: 'Pipeline',
                      type: 'column',
                      fill: 'solid',
                      color: '#B7950B',
                      data: sbar?.map(item => item.pipeline),
                    },
                    {
                      name: 'Meetings',
                      type: 'column',
                      color: '#F4D03F',
                      fill: 'solid',
                      data: sbar?.map(item => item.meeting),
                    },
                    {
                      name: 'Converted',
                      type: 'column',
                      color: '#2ECC71',
                      fill: 'solid',
                      data: sbar?.map(item => item.converted),
                    },
                  ]}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <AppCurrentVisits
                  sx={{
                    border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5",
                    height: saleRaddial1?.dateObject ? "100%" : "100%",

                  }}
                  title="Sales Status"
                  date={
                    saleRaddial1?.dateObject
                      ? `${dayjs(saleRaddial1?.dateObject?.fromDate).format('MM/DD/YYYY')} - ${dayjs(saleRaddial1?.dateObject?.tillDate).format('MM/DD/YYYY')}`
                      : ''
                  }
                  chartData={[
                    { label: 'Prospects', value: saleRaddial?.new || 0 },
                    { label: 'Pipeline', value: saleRaddial?.pipeline || 0 },
                    { label: 'Meetings', value: saleRaddial?.meeting || 0 },

                    { label: 'Converted', value: saleRaddial?.converted || 0 },
                    { label: 'Passiveclient', value: saleRaddial?.passive || 0 },

                  ]}
                  chartColors={[
                    theme.palette.secondary.main,
                    '#B7950B',
                    '#F4D03F',
                    '#2ECC71',
                    '#CB4335',
                  ]}
                  centerLabel="Converted"
                  centerValue={saleRaddial?.converted || 0}
                />

                {/* <Card
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    border: "3px solid #3C6BA5",
    
  }}
>
  <Typography variant="h6" sx={{ color: "#3C6BA5" }}> 
  Sales Status
  </Typography>
  <Typography variant="body2" sx={{ }}> 
    {"date - date"}
  </Typography>

  <CardContent sx={{ textAlign: "center" }}> 
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chart options={chartOptions} series={chartSeries} type="pie" width="410" />
    </Box>
  </CardContent>

  <Box sx={{ display: "flex", justifyContent: "center", mt:-1 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, auto)",
        gap: 1, 
        alignItems: "center",  
      }} 
    >
      {[
        { color: "#C0C0C0", label: "0 - Activity" },
        { color: "#FFA500", label: "1 - 9 Activity" },
        { color: "#B7950B", label: "10 - 50 Activities" },
        { color: "#2ECC71", label: "51+ Activities" },
      ].map(({ color, label }) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              backgroundColor: color,
              borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">{label}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
</Card> */}
              </Grid>

              {/* Date Picker */}
              <Grid container justifyContent="center" sx={{ marginTop: "11px", marginBottom: "-11px" }}>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueee.fromDate ? dayjs(valueee.fromDate) : null}
                        onChange={(date) => handleDateChange1(date, 'fromDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Typography sx={{ marginTop: "6px", fontSize: "16px" }}>To</Typography>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueee.tillDate ? dayjs(valueee.tillDate) : null}
                        onChange={(date) => handleDateChange1(date, 'tillDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                {/* <Button  color="custom" variant="contained" 
                // onClick={()=>handleOpenDown()}
                onClick={()=>handleExport('salTable', "salesExcelFile.xlsx")}
                sx={{ml:2}}
                >Export
                </Button> */}
                {/* <Grid item>
                  {rec.isTeam === 'all' && (
                <Button
        color="custom"
        variant="contained"
        size="small"
        sx={{ marginRight: '-25px', marginLeft: "15px",marginTop:"5px" }}
        // onClick={()=>toggleButtonLabel()} 
      >
        {buttonLabel}
      </Button>
                  )}
  </Grid>
  <Grid item sx={{ml:5}}>

  <Switch 
  // checked={checked} 
  // onChange={handleChangebtn} 
  onClick={()=>toggleButtonLabel()} 
  inputProps={{ 'aria-label': 'controlled' }} />
             
  </Grid> */}
                <Grid item sx={{
                  ml: {
                    xs: '80%',
                    md: '93.5%'
                  },
                  display: 'flex', mt: -5
                }}>
                  {rec.isTeam === 'all' && (
                    <Typography color={'text.secondary'} sx={{ mt: 1 }}>Active</Typography>
                  )}
                  <Switch
                    checked={active === 'active'}
                    onClick={() => toggleButtonLabel()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ overflowX: 'auto', width: '98%', mt: 2.5, ml: 3 }}>

                <Grid item xs={24} md={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table id="salTable" sx={{ minWidth: 650, border: '3px solid #3C6BA5', borderRadius: "10px" }} aria-label="simple table">
                      <TableHead>
                        <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Name</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Prospects</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Pipeline</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Meetings</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Converted</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Passive</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {allSLData?.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={[
                              { background: index % 2 === 0 ? 'text.background' : tablebg },
                              { '&:last-child td, &:last-child th': { border: 0 } },
                              { '&:hover': { boxShadow: 5 } },
                            ]}
                          >
                            <TableCell sx={{ p: 1, py: 0.5, color: item?.status === "inactive" ? "red" : '' }}>
                              {/* {item.addedBy} */}
                              <span style={{ fontWeight: item.name ? "bold" : "normal" }}>
                                {item.name}
                              </span>
                              {" - "} {
                                item?.role === 'recruiterHead' ? 'Recruitment Head' :
                                  item?.role === 'recruiterManager' ? 'Recruitment Manager' :
                                    item?.role === 'recruiterTeamLead' ? 'Recruitment Lead' :
                                      item?.role === 'recruiter' ? 'Technical Recruiter' :
                                        item?.role === 'recruiterTrainee' ? 'Recruitment Trainee' :
                                          item?.role === 'salesHead' ? 'Sales Head' :
                                            item?.role === 'salesManager' ? 'Sales Manager' :
                                              item?.role === 'salesTeamLead' ? 'Sales Team Lead' :
                                                item?.role === 'salesExecutive' ? 'Sales Executive' :
                                                  item?.role === 'salesTrainee' ? 'Sales Trainee' :
                                                    item?.role === 'benchSalesHead' ? 'Bench Sales Head' :
                                                      item?.role === 'benchSalesManager' ? 'Bench Sales Manager' :
                                                        item?.role === 'benchSalesTeamLead' ? 'Bench Sales Lead' :
                                                          item?.role === 'benchSalesExecutive' ? 'Bench Sales Executive' :
                                                            item?.role === 'admin' ? 'Admin' :
                                                              item?.role === 'superadmin' ? 'Super Admin' :
                                                                item?.role?.replace(/([A-Z])/g, ' $&') || ''
                              }</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.new}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.pipeline}
                              {/* (
                            {Number.isFinite((item.statuses.pipeline / item.statuses.new) * 100)
                              ? ((item.statuses.pipeline / item.statuses.new) * 100).toFixed(2)
                              : 0}
                            %) */}
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.meeting}
                              {/* (
                            {Number.isFinite((item.statuses.meetings / item.statuses.pipeline) * 100)
                              ? ((item.statuses.meetings / item.statuses.pipeline) * 100).toFixed(2)
                              : 0}
                            %) */}
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.converted}
                              (
                              {Number.isFinite((item.converted / item.meeting) * 100)
                                ? ((item.converted / item.meeting) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>

                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.passive}</TableCell>
                          </TableRow>
                        ))}

                        <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>Total</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totals?.totalNew}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totals.totalPipeline}
                            {/* (
                          {Number.isFinite((totals.totalPipeline / totals.totalNew) * 100)
                            ? ((totals.totalPipeline / totals.totalNew) * 100).toFixed(2)
                            : 0}
                          %) */}
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totals.totalMeetings}
                            {/* (
                          {Number.isFinite((totals.totalMeetings / totals.totalPipeline) * 100)
                            ? ((totals.totalMeetings / totals.totalPipeline) * 100).toFixed(2)
                            : 0}
                          %) */}
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totals.totalConverted}
                            (
                            {Number.isFinite((totals.totalConverted / totals.totalMeetings) * 100)
                              ? ((totals.totalConverted / totals.totalMeetings) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totals.totalPassiveclient}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button color="custom" variant="contained"
                    // onClick={()=>handleOpenDown()}
                    onClick={() => handleExport('salTable', "salesExcelFile.xlsx")}
                    sx={{ mt: 1.8, mx: 'auto', display: 'block' }}
                  >Export
                  </Button>
                </Grid>
              </Box>
            </>
          ) : (tab === 'sales' ? (
            <>
              <Grid item xs={12} md={6} lg={8}>
                <AppWebsiteVisits
                  sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}
                  title="Pipeline | Meetings | Converted"
                  chartLabels={sbar?.map(item => item.date.replace(/-/g, "/"))}
                  chartData={[
                    {
                      name: 'Pipeline',
                      type: 'column',
                      fill: 'solid',
                      color: '#B7950B',
                      data: sbar?.map(item => item.pipeline),
                    },
                    {
                      name: 'Meetings',
                      type: 'column',
                      color: '#F4D03F',
                      fill: 'solid',
                      data: sbar?.map(item => item.meeting),
                    },
                    {
                      name: 'Converted',
                      type: 'column',
                      color: '#2ECC71',
                      fill: 'solid',
                      data: sbar?.map(item => item.converted),
                    },
                  ]}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <AppCurrentVisits
                  sx={{
                    border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5",
                    height: saleRaddial?.dateObject ? "100%" : "100%",

                  }}
                  title="Sales Status"
                  date={
                    saleRaddial?.dateObject
                      ? `${dayjs(saleRaddial?.dateObject?.fromDate).format('MM/DD/YYYY')} - ${dayjs(saleRaddial?.dateObject?.tillDate).format('MM/DD/YYYY')}`
                      : ''
                  }
                  chartData={[
                    { label: 'Prospects', value: saleRaddial?.new || 0 },
                    { label: 'Pipeline', value: saleRaddial?.pipeline || 0 },
                    { label: 'Meetings', value: saleRaddial?.meeting || 0 },
                    // { label: 'Passiveclient', value: saleRaddial?.passive || 0 },
                    // { label: 'Converted', value: saleRaddial?.converted || 0 },
                    { label: 'Converted', value: saleRaddial?.converted || 0 },
                    { label: 'Passiveclient', value: saleRaddial?.passive || 0 },

                  ]}
                  chartColors={[
                    theme.palette.secondary.main,
                    '#B7950B',
                    '#F4D03F',
                    '#2ECC71',
                    '#CB4335',
                  ]}
                  centerLabel="Converted"
                  centerValue={saleRaddial?.converted || 0}
                />
                {/* <Card
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    border: "3px solid #3C6BA5",
    
  }}
>
  <Typography variant="h6" sx={{ color: "#3C6BA5" }}> 
  Sales Status
  </Typography>
  <Typography variant="body2" sx={{ }}> 
    {"date - date"}
  </Typography>

  <CardContent sx={{ textAlign: "center" }}> 
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chart options={chartOptions} series={chartSeries} type="pie" width="410" />
    </Box>
  </CardContent>

  <Box sx={{ display: "flex", justifyContent: "center", mt:-1 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, auto)",
        gap: 1, 
        alignItems: "center",  
      }} 
    >
      {[
        { color: "#C0C0C0", label: "0 - Activity" },
        { color: "#FFA500", label: "1 - 9 Activity" },
        { color: "#B7950B", label: "10 - 50 Activities" },
        { color: "#2ECC71", label: "51+ Activities" },
      ].map(({ color, label }) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              backgroundColor: color,
              borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">{label}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
</Card> */}
              </Grid>

              {/* Date Picker */}
              <Grid container justifyContent="center" sx={{ marginTop: "11px", marginBottom: "-11px" }}>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueee.fromDate ? dayjs(valueee.fromDate) : null}
                        onChange={(date) => handleDateChange1(date, 'fromDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Typography sx={{ marginTop: "6px", fontSize: "16px" }}>To</Typography>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueee.tillDate ? dayjs(valueee.tillDate) : null}
                        onChange={(date) => handleDateChange1(date, 'tillDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                {/* <Grid item>
                  {rec.isTeam === 'all' && (
                <Button
        color="custom"
        variant="contained"
        size="small"
        sx={{ marginRight: '-25px', marginLeft: "15px", marginTop:"5px" }}
        // onClick={()=>toggleButtonLabel()} 
      >
        {buttonLabel}
      </Button>
                  )}
  </Grid>
  <Grid item sx={{ml:5}}>

  <Switch 
  // checked={checked} 
  // onChange={handleChangebtn} 
  onClick={()=>toggleButtonLabel()} 
  inputProps={{ 'aria-label': 'controlled' }} />
             
  </Grid> */}
                {/* <Button  color="custom" variant="contained" 
                // onClick={()=>handleOpenDown()}
                onClick={()=>handleExport('salTable', "salesExcelFile.xlsx")}
                sx={{ml:2}}
                >Export
                </Button> */}

                <Grid item sx={{
                  ml: {
                    xs: '80%',
                    md: '93.5%'
                  },
                  display: 'flex', mt: -5
                }}>
                  {rec.isTeam === 'all' && (
                    <Typography color={'text.secondary'} sx={{ mt: 1 }}>Active</Typography>
                  )}
                  <Switch
                    checked={active === 'active'}
                    onClick={() => toggleButtonLabel()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ overflowX: 'auto', width: '98%', mt: 2.5, ml: 3 }}>

                <Grid item xs={24} md={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table id="salTable" sx={{ minWidth: 650, border: '3px solid #3C6BA5', borderRadius: "10px" }} aria-label="simple table">
                      <TableHead>
                        <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Name</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Prospects</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Pipeline</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Meetings</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Converted</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Passive</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableByDate1?.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={[
                              { background: index % 2 === 0 ? 'text.background' : tablebg },
                              { '&:last-child td, &:last-child th': { border: 0 } },
                              { '&:hover': { boxShadow: 5 } },
                            ]}
                          >
                            <TableCell sx={{ p: 1, py: 0.5, color: item?.status === "inactive" ? "red" : '' }}>
                              <span style={{ fontWeight: item.name ? "bold" : "normal" }}>
                                {item.name}
                              </span>
                              {" - "} {
                                item?.role === 'recruiterHead' ? 'Recruitment Head' :
                                  item?.role === 'recruiterManager' ? 'Recruitment Manager' :
                                    item?.role === 'recruiterTeamLead' ? 'Recruitment Lead' :
                                      item?.role === 'recruiter' ? 'Technical Recruiter' :
                                        item?.role === 'recruiterTrainee' ? 'Recruitment Trainee' :
                                          item?.role === 'salesHead' ? 'Sales Head' :
                                            item?.role === 'salesManager' ? 'Sales Manager' :
                                              item?.role === 'salesTeamLead' ? 'Sales Team Lead' :
                                                item?.role === 'salesExecutive' ? 'Sales Executive' :
                                                  item?.role === 'salesTrainee' ? 'Sales Trainee' :
                                                    item?.role === 'benchSalesHead' ? 'Bench Sales Head' :
                                                      item?.role === 'benchSalesManager' ? 'Bench Sales Manager' :
                                                        item?.role === 'benchSalesTeamLead' ? 'Bench Sales Lead' :
                                                          item?.role === 'benchSalesExecutive' ? 'Bench Sales Executive' :
                                                            item?.role === 'admin' ? 'Admin' :
                                                              item?.role === 'superadmin' ? 'Super Admin' :
                                                                item?.role?.replace(/([A-Z])/g, ' $&') || '-'
                              }</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.new}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.pipeline} (
                              {Number.isFinite((item.pipeline / item.new) * 100)
                                ? ((item.pipeline / item.new) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.meeting} (
                              {Number.isFinite((item.meeting / item.pipeline) * 100)
                                ? ((item.meeting / item.pipeline) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.converted} (
                              {Number.isFinite((item.converted / item.meeting) * 100)
                                ? ((item.converted / item.meeting) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.passive}</TableCell>
                          </TableRow>
                        ))}

                        <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>Total</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totallSales?.new}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totallSales?.pipeline} (
                            {Number.isFinite((totallSales?.pipeline / totallSales?.new) * 100)
                              ? ((totallSales?.pipeline / totallSales?.new) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totallSales?.meeting} (
                            {Number.isFinite((totallSales?.meeting / totallSales?.pipeline) * 100)
                              ? ((totallSales?.meeting / totallSales?.pipeline) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totallSales?.converted} (
                            {Number.isFinite((totallSales?.converted / totallSales?.meeting) * 100)
                              ? ((totallSales?.converted / totallSales?.meeting) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totallSales?.passive}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button color="custom" variant="contained"
                    // onClick={()=>handleOpenDown()}
                    onClick={() => handleExport('salTable', "salesExcelFile.xlsx")}
                    sx={{ mt: 1.8, mx: 'auto', display: 'block' }}
                  >Export
                  </Button>
                </Grid>
              </Box>
            </>
          ) : null)}

          {tab === 're' && (
            <>
              <Grid item xs={12} md={6} lg={8}>
                <AppWebsiteVisits sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}
                  // title="Revenue" sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}
                  // title="Client Status" sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}
                  // subheader="(+43%) than last year"

                  title="Submissions | Interviews | Placements"

                  // chartLabels={[
                  //   '01/01/2003',
                  //   '02/01/2003',
                  //   '03/01/2003',
                  //   '04/01/2003',
                  //   '05/01/2003',
                  //   '06/01/2003',
                  //   '07/01/2003',
                  //   '08/01/2003',
                  //   '09/01/2003',
                  //   '10/01/2003',
                  //   '11/01/2003',
                  // ]}
                  // chartData={[
                  //   {
                  //     // name: 'Last Month',
                  //     name: 'Submissions',
                  //     type: 'column',
                  //     fill: 'solid',
                  //     color: '#B7950B',
                  //     data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                  //   },
                  //   {
                  //     // name: 'Current Month',
                  //     name: 'Interviews',
                  //     type: 'column',
                  //     // type: 'area',
                  //     color: '#F4D03F',
                  //     fill: 'solid',
                  //     data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                  //   },
                  //   {
                  //     // name: 'Current Month',
                  //     name: 'Placements',
                  //     type: 'column',
                  //     // type: 'area',
                  //     color: '#F4D03F',
                  //     fill: 'solid',
                  //     data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                  //   }
                  // ]}

                  chartLabels={[...rbarclient?.map((item) => item.date.replace(/-/g, "/"))]}
                  chartData={[
                    {
                      name: 'Submissions',
                      type: 'column',
                      fill: 'solid',
                      color: '#B7950B',
                      data: [...rbarclient?.map((item) => item.submission)],
                    },
                    {
                      name: 'Interviews',
                      type: 'column',
                      // type: 'area',
                      color: '#F4D03F',
                      fill: 'solid',
                      data: [...rbarclient?.map((item) => item.interview)],
                    },
                    {
                      name: 'Placements',
                      type: 'column',
                      // type: 'line',
                      color: '#2ECC71',
                      fill: 'solid',
                      data: [...rbarclient?.map((item) => item.placements)],
                    },
                  ]}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <AppCurrentVisits sx={{
                  border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5",
                  height: clientRadDate?.dateObject ? "100%" : "100%",

                }}
                  title="Client Status"

                  date={
                    clientRadDate?.dateObject
                      ? `${dayjs(clientRadDate?.dateObject?.fromDate).format('MM/DD/YYYY')} - ${dayjs(clientRadDate?.dateObject?.tillDate).format('MM/DD/YYYY')}`
                      : ''
                  }

                  chartData={[
                    // { label: 'Prospects', value: recRaddial?.totalprospectsCounnts || 0 },
                    { label: 'Submissions', value: clientRad?.submittedCount || 0 },
                    { label: 'Interviews', value: clientRad?.interviewCount || 0 },
                    { label: 'Placements', value: clientRad?.placementCount || 0 },
                    { label: 'Backouts', value: clientRad?.backoutCount || 0 },
                    // { label: 'Backouts', value: clientRad?.backoutCount || 0 },
                  ]}
                  chartColors={[
                    // theme.palette.secondary.main,
                    '#B7950B',
                    '#F4D03F',
                    '#2ECC71',
                    '#CB4335',

                  ]}
                  // val={per.RecruitementPercenatge}
                  centerLabel="Placements"
                  centerValue={clientRad?.placementCount}

                // chartData={[
                //   { label: 'Submissions', value: 10 },
                //   { label: 'Interviews', value: 20 },
                //   { label: 'Placments', value: 30 },
                //   { label: 'Backouts', value: 30 }
                // ]}
                // chartColors={[
                //   theme.palette.secondary.main,
                //   '#B7950B',
                //   '#F4D03F',
                //   '#2ECC71',
                //   '#CB4335',
                // ]}
                //  centerLabel="Placements"

                />
              </Grid>

              <Grid container justifyContent="center" sx={{ marginTop: "11px", marginBottom: "-11px" }}>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueeee.fromDate ? dayjs(valueeee.fromDate) : null}
                        onChange={(date) => handleDateChange2(date, 'fromDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Typography sx={{ marginTop: "6px", fontSize: "16px" }}>To</Typography>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueeee.tillDate ? dayjs(valueeee.tillDate) : null}
                        onChange={(date) => handleDateChange2(date, 'tillDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                {/* <Grid item>
                  {rec.isTeam === 'all' && (
                <Button
        color="custom"
        variant="contained"
        size="small"
        sx={{ marginRight: '-25px', marginLeft: "15px",marginTop:"5px" }}
        // onClick={()=>toggleButtonLabel()} 
      >
        {buttonLabel}
      </Button>
                  )}
  </Grid>
  <Grid item sx={{ml:5}}>

  <Switch 
  // checked={checked} 
  // onChange={handleChangebtn} 
  onClick={()=>toggleButtonLabel()} 
  inputProps={{ 'aria-label': 'controlled' }} />
             
  </Grid> */}
                {/* <Button  color="custom" variant="contained" 
                // onClick={()=>handleOpenDown()}
                onClick={()=>handleExport('clientTable', "clientExcelFile.xlsx")}
                sx={{ml:2}}
                >Export
                </Button> */}

                <Grid item sx={{
                  ml: {
                    xs: '80%',
                    md: '93.5%'
                  },
                  display: 'flex', mt: -5
                }}>
                  {rec.isTeam === 'all' && (
                    <Typography color={'text.secondary'} sx={{ mt: 1 }}>Active</Typography>
                  )}
                  <Switch
                    checked={active === 'active'}
                    onClick={() => toggleButtonLabel()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ overflowX: 'auto', width: '98%', mt: 2.5, ml: 3 }}>
                <Grid item xs={24} md={12} lg={12} >
                  <TableContainer component={Paper}>
                    {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                    <Table id="clientTable" sx={{ minWidth: 650, border: '3px solid #3C6BA5', borderRadius: "10px" }} aria-label="simple table">

                      <TableHead>
                        <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Name</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Submissions</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Unqualified</TableCell>
                          {/* <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Finalised</TableCell> */}
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Interviews</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Placements</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Backouts</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableByDateClient?.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={[
                              { background: index % 2 === 0 ? 'text.background' : tablebg },
                              { '&:last-child td, &:last-child th': { border: 0 } },
                              { '&:hover': { boxShadow: 5 } },
                            ]}
                          >
                            <TableCell sx={{ p: 1, py: 0.5 }} style={{ color: item.status !== "Active" ? "red" : "", fontWeight: "bold" }}>{item.name}</TableCell>
                            {/* <TableCell sx={{ p: 1, py: 0.5 }}>{item.prospects}</TableCell> */}
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.submittedCount}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.Unqualified} (
                              {Number.isFinite((item.Unqualified / item.submittedCount) * 100)
                                ? ((item.Unqualified / item.submittedCount) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.interviewCount} (
                              {Number.isFinite((item.interviewCount / item.submittedCount) * 100)
                                ? ((item.interviewCount / item.submittedCount) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.placementCount} (
                              {Number.isFinite((item.placementCount / item.submittedCount) * 100)
                                ? ((item.placementCount / item.submittedCount) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.backoutCount} (
                              {Number.isFinite((item.backoutCount / item.placementCount) * 100)
                                ? ((item.backoutCount / item.placementCount) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>Total</TableCell>
                          {/* <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall.totalprospectsCounnts}</TableCell> */}
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{tableByDateClientTotal?.totalSubmittedCount}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {tableByDateClientTotal.totalUnqualifiedCount} (
                            {Number.isFinite((tableByDateClientTotal.totalUnqualifiedCount / tableByDateClientTotal.totalSubmittedCount) * 100)
                              ? ((tableByDateClientTotal.totalUnqualifiedCount / tableByDateClientTotal.totalSubmittedCount) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {tableByDateClientTotal.totalInterviewCount} (
                            {Number.isFinite((tableByDateClientTotal.totalInterviewCount / tableByDateClientTotal.totalSubmittedCount) * 100)
                              ? ((tableByDateClientTotal.totalInterviewCount / tableByDateClientTotal.totalSubmittedCount) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {tableByDateClientTotal.totalPlacementCount} (
                            {Number.isFinite((tableByDateClientTotal.totalPlacementCount / tableByDateClientTotal.totalSubmittedCount) * 100)
                              ? ((tableByDateClientTotal.totalPlacementCount / tableByDateClientTotal.totalSubmittedCount) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {tableByDateClientTotal.totalBackoutCount} (
                            {Number.isFinite((tableByDateClientTotal.totalBackoutCount / tableByDateClientTotal.totalSubmittedCount) * 100)
                              ? ((tableByDateClientTotal.totalBackoutCount / tableByDateClientTotal.totalSubmittedCount) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button color="custom" variant="contained"
                    // onClick={()=>handleOpenDown()}
                    onClick={() => handleExport('clientTable', "clientExcelFile.xlsx")}
                    sx={{ mt: 1.8, mx: 'auto', display: 'block' }}
                  >Export
                  </Button>

                </Grid>
              </Box>
            </>
          )}

          {tab === 'bench' && (
            <>
              <Grid item xs={12} md={6} lg={8}>
                <AppWebsiteVisits sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}

                  title="Submissions | Interviews | Placements"
                  chartLabels={[...rbarbench?.map((item) => item.date.replace(/-/g, "/"))]}
                  chartData={[
                    {
                      name: 'Submissions',
                      type: 'column',
                      fill: 'solid',
                      color: '#B7950B',
                      data: [...rbarbench?.map((item) => item.submission)],
                    },
                    {
                      name: 'Interviews',
                      type: 'column',
                      // type: 'area',
                      color: '#F4D03F',
                      fill: 'solid',
                      data: [...rbarbench?.map((item) => item.interview)],
                    },
                    {
                      name: 'Placements',
                      type: 'column',
                      // type: 'line',
                      color: '#2ECC71',
                      fill: 'solid',
                      data: [...rbarbench?.map((item) => item.placements)],
                    },
                  ]}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <AppCurrentVisits sx={{
                  border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5",
                  height: benchRadDate?.dateObject ? "100%" : "100%",

                }}
                  title="Bench Status"

                  date={
                    benchRadDate?.dateObject
                      ? `${dayjs(benchRadDate?.dateObject?.fromDate).format('MM/DD/YYYY')} - ${dayjs(benchRadDate?.dateObject?.tillDate).format('MM/DD/YYYY')}`
                      : ''
                  }

                  chartData={[
                    { label: 'Prospects', value: benchRad?.prospectCount || 0 },
                    { label: 'Submissions', value: benchRad?.submittedCount || 0 },
                    { label: 'Interviews', value: benchRad?.interviewCount || 0 },
                    { label: 'Placements', value: benchRad?.placementCount || 0 },
                    { label: 'Backouts', value: benchRad?.backoutCount || 0 },

                  ]}
                  chartColors={[
                    theme.palette.secondary.main,
                    '#B7950B',
                    '#F4D03F',
                    '#2ECC71',
                    '#CB4335',

                  ]}

                  centerLabel="Placements"
                  centerValue={benchRad?.placementCount}

                />
                {/* <Card
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    border: "3px solid #3C6BA5",
    
  }}
>
  <Typography variant="h6" sx={{ color: "#3C6BA5" }}> 
    Bench Status
  </Typography>
  <Typography variant="body2" sx={{ }}> 
    {"date - date"}
  </Typography>

  <CardContent sx={{ textAlign: "center" }}> 
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chart options={chartOptions} series={chartSeries} type="pie" width="410" />
    </Box>
  </CardContent>

  <Box sx={{ display: "flex", justifyContent: "center", mt:-1 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, auto)",
        gap: 1, 
        alignItems: "center",  
      }} 
    >
      {[
        { color: "#C0C0C0", label: "0 - Activity" },
        { color: "#FFA500", label: "1 - 9 Activity" },
        { color: "#B7950B", label: "10 - 50 Activities" },
        { color: "#2ECC71", label: "51+ Activities" },
      ].map(({ color, label }) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              backgroundColor: color,
              borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">{label}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
</Card> */}
              </Grid>

              <Grid container justifyContent="center" sx={{ marginTop: "11px", marginBottom: "-11px" }}>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueeee.fromDate ? dayjs(valueeee.fromDate) : null}
                        onChange={(date) => handleDateChange2(date, 'fromDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Typography sx={{ marginTop: "6px", fontSize: "16px" }}>To</Typography>
                <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                  <FormControl fullWidth size='small'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                        value={valueeee.tillDate ? dayjs(valueeee.tillDate) : null}
                        onChange={(date) => handleDateChange2(date, 'tillDate')}
                        className="dash_dt"
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                {/* <Grid item>
                  {rec.isTeam === 'all' && (
                <Button
        color="custom"
        variant="contained"
        size="small"
        sx={{ marginRight: '-25px', marginLeft: "15px",marginTop:"5px" }}
        // onClick={()=>toggleButtonLabel()} 
      >
        {buttonLabel}
      </Button>
                  )}
  </Grid>
  <Grid item sx={{ml:5}}>

  <Switch 
  // checked={checked} 
  // onChange={handleChangebtn} 
  onClick={()=>toggleButtonLabel()} 
  inputProps={{ 'aria-label': 'controlled' }} />
             
  </Grid> */}
                {/* <Button  color="custom" variant="contained" 
                // onClick={()=>handleOpenDown()}
                onClick={()=>handleExport('benchTable', "benchExcelFile.xlsx")}
                sx={{ml:2}}
                >Export
                </Button> */}

                <Grid item sx={{
                  ml: {
                    xs: '80%',
                    md: '93.5%'
                  },
                  display: 'flex', mt: -5
                }}>
                  {rec.isTeam === 'all' && (
                    <Typography color={'text.secondary'} sx={{ mt: 1 }}>Active</Typography>
                  )}
                  <Switch
                    checked={active === 'active'}
                    onClick={() => toggleButtonLabel()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ overflowX: 'auto', width: '98%', mt: 2.5, ml: 3 }}>
                <Grid item xs={24} md={12} lg={12} >
                  <TableContainer component={Paper}>
                    {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                    <Table id="benchTable" sx={{ minWidth: 650, border: '3px solid #3C6BA5', borderRadius: "10px" }} aria-label="simple table">

                      <TableHead>
                        <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Name</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Prospects</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Submissions</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Unqualified</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Interviews</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Placements</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Backouts</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableByDate2?.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={[
                              { background: index % 2 === 0 ? 'text.background' : tablebg },
                              { '&:last-child td, &:last-child th': { border: 0 } },
                              { '&:hover': { boxShadow: 5 } },
                            ]}
                          >
                            <TableCell sx={{ p: 1, py: 0.5, color: item?.status === "inactive" ? "red" : '' }}>
                              <span style={{ fontWeight: item.name ? "bold" : "normal" }}>
                                {item.name}
                              </span>
                              {" - "} {
                                item?.role === 'recruiterHead' ? 'Recruitment Head' :
                                  item?.role === 'recruiterManager' ? 'Recruitment Manager' :
                                    item?.role === 'recruiterTeamLead' ? 'Recruitment Lead' :
                                      item?.role === 'recruiter' ? 'Technical Recruiter' :
                                        item?.role === 'recruiterTrainee' ? 'Recruitment Trainee' :
                                          item?.role === 'salesHead' ? 'Sales Head' :
                                            item?.role === 'salesManager' ? 'Sales Manager' :
                                              item?.role === 'salesTeamLead' ? 'Sales Team Lead' :
                                                item?.role === 'salesExecutive' ? 'Sales Executive' :
                                                  item?.role === 'salesTrainee' ? 'Sales Trainee' :
                                                    item?.role === 'benchSalesHead' ? 'Bench Sales Head' :
                                                      item?.role === 'benchSalesManager' ? 'Bench Sales Manager' :
                                                        item?.role === 'benchSalesTeamLead' ? 'Bench Sales Lead' :
                                                          item?.role === 'benchSalesExecutive' ? 'Bench Sales Executive' :
                                                            item?.role === 'admin' ? 'Admin' :
                                                              item?.role === 'superadmin' ? 'Super Admin' :
                                                                item?.role?.replace(/([A-Z])/g, ' $&') || '-'
                              }</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.prospects}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>{item.submission}</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.unqualified} (
                              {Number.isFinite((item.unqualified / item.submission) * 100)
                                ? ((item.unqualified / item.submission) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.interview} (
                              {Number.isFinite((item.interview / item.submission) * 100)
                                ? ((item.interview / item.submission) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.placements} (
                              {Number.isFinite((item.placements / item.submission) * 100)
                                ? ((item.placements / item.submission) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5 }}>
                              {item.backout} (
                              {Number.isFinite((item.backout / item.placements) * 100)
                                ? ((item.backout / item.placements) * 100).toFixed(2)
                                : 0}
                              %)
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>Total</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall2.totalprospectsCounnts}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>{totall2.totalCandidateSubmission}</TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall2.totalCandidateUnqualified} (
                            {Number.isFinite((totall2.totalCandidateUnqualified / totall2.totalCandidateSubmission) * 100)
                              ? ((totall2.totalCandidateUnqualified / totall2.totalCandidateSubmission) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall2.totalCandidateInterview} (
                            {Number.isFinite((totall2.totalCandidateInterview / totall2.totalCandidateSubmission) * 100)
                              ? ((totall2.totalCandidateInterview / totall2.totalCandidateSubmission) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall2.totalCandidatePlacements} (
                            {Number.isFinite((totall2.totalCandidatePlacements / totall2.totalCandidateSubmission) * 100)
                              ? ((totall2.totalCandidatePlacements / totall2.totalCandidateSubmission) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                          <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                            {totall2.totalCandidateBackout} (
                            {Number.isFinite((totall2.totalCandidateBackout / totall2.totalCandidatePlacements) * 100)
                              ? ((totall2.totalCandidateBackout / totall2.totalCandidatePlacements) * 100).toFixed(2)
                              : 0}
                            %)
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button color="custom" variant="contained"
                    // onClick={()=>handleOpenDown()}
                    onClick={() => handleExport('benchTable', "benchExcelFile.xlsx")}
                    sx={{ mt: 1.8, mx: 'auto', display: 'block' }}
                  >Export
                  </Button>
                </Grid>
              </Box>
            </>
          )}
          {
            tab === "placement" && (
              <>
                <Grid item xs={12} md={6} lg={8}>
                  <AppWebsiteVisits sx={{ border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5" }}

                    // title="Bill Rate | Pay rate | Profit"
                    title="Placements | Active | Inactive"
                    chartLabels={[...placementbar?.map((item) => item.date.replace(/-/g, "/"))]}
                    chartData={[


                      {
                        // name: 'Profit',
                        name: 'Placements',
                        type: 'column',
                        // type: 'line',
                        // color: '#2ECC71', 
                        color: '#B7950B',
                        fill: 'solid',
                        data: [...placementbar?.map((item) => item.placementCount)],
                      },

                      {
                        // name: 'Pay rate',
                        name: 'Active',
                        type: 'column',
                        // type: 'area',
                        // color: '#F4D03F',
                        color: '#2ECC71',
                        fill: 'solid',
                        data: [...placementbar?.map((item) => item.startedCount)],
                      },
                      {
                        // name: 'Bill Rate ', 
                        name: 'Inactive',
                        type: 'column',
                        fill: 'solid',
                        // color: '#B7950B',
                        color: '#CB4335',
                        data: [...placementbar?.map((item) => item.projectEndedCount)],
                      },


                    ]}
                  />
                </Grid>

                {/* <Grid item xs={12} md={6} lg={4}>

                            <Card
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    border: "3px solid #3C6BA5",
    
  }}
>
  <Typography variant="h6" sx={{ color: "#3C6BA5" }}> 
     Placement
  </Typography>
  <Typography variant="body2" sx={{ }}> 
{`${formatDate(fromDate)} - ${formatDate(fromDate1)}`}

  </Typography>

  <CardContent sx={{ textAlign: "center" }}> 
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chart options={chartOptions} series={chartSeries} type="pie" width="410" />
    </Box>
  </CardContent>

  <Box sx={{ display: "flex", justifyContent: "center", mt:-1 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, auto)",
        gap: 1, 
        alignItems: "center",  
      }} 
    >
      {[
        { color: "#C0C0C0", label: "expected " },
        // { color: "#FFA500", label: "1 - 9 Activity" },
        // { color: "#B7950B", label: "10 - 50 Activities" },
        { color: "#2ECC71", label: "placement" },
      ].map(({ color, label }) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 15,
              height: 15,
              backgroundColor: color,
          //    borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">{label}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
                           </Card>

                </Grid> */}

                <Grid item xs={12} md={6} lg={4}>
                  <AppCurrentVisits sx={{
                    border: '3px solid #3C6BA5', textAlign: 'center', color: "#3C6BA5",
                    height: placementPieChartDate?.dateObject ? "100%" : "100%",

                  }}
                    title="Placements"

                    date={
                      placementPieChartDate?.dateObject
                        ? `${dayjs(placementPieChartDate?.dateObject?.fromDate).format('MM/DD/YYYY')} - ${dayjs(placementPieChartDate?.dateObject?.tillDate).format('MM/DD/YYYY')}`
                        : ''
                    }

                    chartData={[
                      // { label: 'Prospects', value: recRaddial?.totalprospectsCounnts || 0 },
                      { label: 'Placements', value: placementPieChartData?.placementCount || 0 },
                      { label: 'Inactive', value: placementPieChartData?.projectEndedCount || 0 },
                      { label: 'Active', value: placementPieChartData?.startedCount || 0 },

                      // { label: 'Backouts', value: clientRad?.backoutCount || 0 },
                      // { label: 'Backouts', value: clientRad?.backoutCount || 0 },
                    ]}
                    chartColors={[
                      // theme.palette.secondary.main,
                      // '#F4D03F',
                      '#B7950B',
                      '#CB4335',
                      '#2ECC71',


                    ]}
                    // val={per.RecruitementPercenatge}
                    centerLabel="Started"
                    centerValue={placementPieChartData?.startedCount}

                  // chartData={[
                  //   { label: 'Submissions', value: 10 },
                  //   { label: 'Interviews', value: 20 },
                  //   { label: 'Placments', value: 30 },
                  //   { label: 'Backouts', value: 30 }
                  // ]}
                  // chartColors={[
                  //   theme.palette.secondary.main,
                  //   '#B7950B',
                  //   '#F4D03F',
                  //   '#2ECC71',
                  //   '#CB4335',
                  // ]}
                  //  centerLabel="Placements"

                  />
                </Grid>
















                <Grid container justifyContent="center" sx={{ marginTop: "11px", marginBottom: "-11px" }}>
                  <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                    <FormControl fullWidth size='small'>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          //   slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                          //    value={valueeee.fromDate ? dayjs(valueeee.fromDate) : null}
                          ///   onChange={(date) => handleDateChange2(date, 'fromDate')}
                          value={dateValue.fromMonth ? dayjs(dateValue.fromMonth) : null}

                          onChange={(date) => {
                            setDateValue(prev => ({
                              ...prev,
                              fromMonth: date ? dayjs(date).format("YYYY-MM") : ""
                            }));
                            placementTableData(dayjs(date).format("YYYY-MM"), "")
                          }
                          }
                          className="dash_dt"
                          views={['month', 'year']}
                          slotProps={{
                            textField: {
                              size: 'small',
                            },
                            openPickerButton: {
                              sx: { color: '#fff' },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Typography sx={{ marginTop: "6px", fontSize: "16px" }}>To</Typography>
                  <Grid item sx={{ width: '13%', mx: '0.5%', backgroundColor: '#3C6BA5', borderRadius: "7px" }}>
                    <FormControl fullWidth size='small'>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          //   slotProps={{ openPickerButton: { sx: { color: '#fff' } }, textField: { size: 'small' } }}
                          //   value={valueeee.tillDate ? dayjs(valueeee.tillDate) : null}
                          //   onChange={(date) => handleDateChange2(date, 'tillDate')}

                          //     value={dateValue.tillMonth}
                          value={dateValue.tillMonth ? dayjs(dateValue.tillMonth) : null}
                          //  value={dateValue.tillMonth ? dayjs(dateValue.tillMonth).format("YYYY-MM"): ""}
                          onChange={(date) => {
                            setDateValue(prev => ({
                              ...prev,
                              tillMonth: date ? dayjs(date).format("YYYY-MM") : ""
                            }));

                            placementTableData("", dayjs(date).format("YYYY-MM"))

                          }}
                          className="dash_dt"
                          views={['month', 'year']}
                          slotProps={{
                            textField: {
                              size: 'small',
                            },
                            openPickerButton: {
                              sx: { color: '#fff' },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  {/* <Grid item>
                  {rec.isTeam === 'all' && (
                <Button
        color="custom"
        variant="contained"
        size="small"
        sx={{ marginRight: '-25px', marginLeft: "15px",marginTop:"5px" }}
        // onClick={()=>toggleButtonLabel()} 
      >
        {buttonLabel}
      </Button>
                  )}
  </Grid>
  <Grid item sx={{ml:5}}>

  <Switch 
  // checked={checked} 
  // onChange={handleChangebtn} 
  onClick={()=>toggleButtonLabel()} 
  inputProps={{ 'aria-label': 'controlled' }} />
             
  </Grid> */}
                  {/* <Button  color="custom" variant="contained" 
                // onClick={()=>handleOpenDown()}
                onClick={()=>handleExport('benchTable', "benchExcelFile.xlsx")}
                sx={{ml:2}}
                >Export
                </Button> */}

                  {/* <Grid item sx={{ ml: {
      xs: '80%',  
      md: '93.5%'
    },
     display: 'flex', mt: -5 }}>
                  {rec.isTeam === 'all' && (
                    <Typography color={'text.secondary'} sx={{ mt: 1 }}>Active</Typography>
                  )}
                  <Switch
                    checked={active === 'active'}
                    onClick={() => toggleButtonLabel()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Grid> */}
                </Grid>








                <Box sx={{ overflowX: 'auto', width: '98%', mt: 2.5, ml: 3 }}>
                  <Grid item xs={24} md={12} lg={12} >
                    <TableContainer component={Paper}>
                      {/* <Table sx={{ minWidth: 650 }} aria-label="simple table"> */}
                      <Table id="placementTable" sx={{ minWidth: 650, border: '3px solid #3C6BA5', borderRadius: "10px" }} aria-label="simple table">
                        <TableHead>
                          <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Name</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Project</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Billable Hours</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Pay Rate</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Bill Rate</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Profit</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Amount</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Expenses</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Profit</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>



                          {tableDataPlacement?.map((item, index) => (
                            <TableRow
                              key={index}
                              sx={[
                                { background: index % 2 === 0 ? 'text.background' : tablebg },
                                { '&:last-child td, &:last-child th': { border: 0 } },
                                { '&:hover': { boxShadow: 5 } },
                              ]}
                            >
                              <TableCell sx={{ p: 1, py: 0.5, color: item?.status === "inactive" ? "red" : '' }}>
                                {item.name || "-"}

                              </TableCell>

                              <TableCell sx={{ p: 1, py: 0.5 }}>{item.projects || "-"}</TableCell>


                              <TableCell sx={{ p: 1, py: 0.5 }}>

                                {item.billableHours || "-"}



                              </TableCell>


                              <TableCell sx={{ p: 1, py: 0.5 }}>


                                {/* {item?.payRate ? `$${item.payRate}` : "-"} */}



                                {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${item?.payRate}/Hr`}

                              </TableCell>


                              <TableCell sx={{ p: 1, py: 0.5 }}>
                                {/* {item?.billRate ? `$${item?.billRate}` : "-"} */}
                                {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${item?.billRate}/Hr`}
                              </TableCell>

                              {/* <TableCell sx={{ p: 1, py: 0.5 }}>

                          
                                `${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} 
                                
                               
                                ${item?.profit}${item?.chargeType === "hourly" ? "Hr" : " k"}


                              </TableCell> */}
{/* 
                              <TableCell sx={{ p: 1, py: 0.5 }}>
                                {`${localStorage.getItem("country") === "INDIA" ? "₹" :
                                  localStorage.getItem("country") === "UK" ? "£" : "$"}
                                ${item?.profit}${item?.chargeType === "hourly" ? "/Hr" : "k"}`}




                                {`${item?.profit}${item?.chargeType === "hourly"
                                  ? "/Hr"
                                  : localStorage.getItem("country") === "INDIA"
                                    ? "Lac"
                                    : "k"
                                  }`}



                              </TableCell> */}



                              <TableCell sx={{ p: 1, py: 0.5 }}>
                                {`${localStorage.getItem("country") === "INDIA"
                                  ? "₹"
                                  : localStorage.getItem("country") === "UK"
                                    ? "£"
                                    : "$"
                                  }${item?.profit}${item?.chargeType === "hourly"
                                    ? "/Hr"
                                    : ""
                                  }`}
                              </TableCell>







                              <TableCell sx={{ p: 1, py: 0.5 }}>

                                {/* {item?.amount ? `$${item?.amount}` : "-"} */}
                                {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${item?.amount}`}

                              </TableCell>

                              <TableCell sx={{ p: 1, py: 0.5 }}>

                                {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${item?.expenses}`}
                                {/* {item?.expenses ? `$${item?.expenses}` : "-"} */}

                              </TableCell>

                              <TableCell sx={{ p: 1, py: 0.5 }}>
                                {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${item?.netProfit}`}
                                {/* {item?.netProfit ? `$${item?.netProfit}` : "-"} */}

                              </TableCell>
                            </TableRow>
                          ))}
                          <TableRow sx={{ backgroundColor: 'text.secondary' }}>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>Total</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {placementGrandTotal.projects ? `${placementGrandTotal.projects}` : "-"}
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {placementGrandTotal.billableHours ? `${placementGrandTotal.billableHours}` : "-"}
                            </TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {/* {placementGrandTotal.payRate ? `$ ${placementGrandTotal.payRate}` : "-"} */}
                              {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${placementGrandTotal?.payRate}`}



                            </TableCell>



                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>


                              {/* {placementGrandTotal.billRate ? `$${placementGrandTotal.billRate}` : "-"} */}

                              {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${placementGrandTotal?.billRate}`}
                            </TableCell>



                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {/* {placementGrandTotal.profit ? `$${placementGrandTotal.profit}` : "-"} */}

                              {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${placementGrandTotal?.profit}`}

                            </TableCell>





                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {/* {placementGrandTotal.amount ? `$${placementGrandTotal.amount}` : "-"} */}


                              {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${placementGrandTotal?.amount}`}
                            </TableCell>







                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {/* {placementGrandTotal.expenses ? `$${placementGrandTotal.expenses}` : "-"} */}


                              {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${placementGrandTotal?.expenses}`}


                            </TableCell>






                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', border: '1px solid #3C6BA5', fontWeight: "bold" }}>
                              {/* {placementGrandTotal.netProfit ? `$${placementGrandTotal.netProfit}` : "-"} */}
                              {`${localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"} ${placementGrandTotal?.netProfit}`}


                            </TableCell>

                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Button color="custom" variant="contained"

                      onClick={() => handleExport('placementTable', "placementExcelFile.xlsx")}
                      sx={{ mt: 1.8, mx: 'auto', display: 'block' }}
                    >Export
                    </Button>
                  </Grid>
                </Box>











              </>
            )
          }

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Conversion Rates"
              subheader="(+43%) than last year"
              chartData={[
                { label: 'Italy', value: 400 },
                { label: 'Japan', value: 430 },
                { label: 'China', value: 448 },
                { label: 'Canada', value: 470 },
                { label: 'France', value: 540 },
                { label: 'Germany', value: 580 },
                { label: 'South Korea', value: 690 },
                { label: 'Netherlands', value: 1100 },
                { label: 'United States', value: 1200 },
                { label: 'United Kingdom', value: 1380 },
              ]}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject
              title="Current Subject"
              chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
              chartData={[
                { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
              ]}
              chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate
              title="News Update"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: faker.name.jobTitle(),
                description: faker.name.jobTitle(),
                image: `/assets/images/covers/cover_${index + 1}.jpg`,
                postedAt: faker.date.recent(),
              }))}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  '1983, orders, $4220',
                  '12 Invoices have been paid',
                  'Order #37745 from September',
                  'New order placed #XF-2356',
                  'New order placed #XF-2346',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite
              title="Traffic by Site"
              list={[
                {
                  name: 'FaceBook',
                  value: 323234,
                  icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} />,
                },
                {
                  name: 'Google',
                  value: 341212,
                  icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} />,
                },
                {
                  name: 'Linkedin',
                  value: 411213,
                  icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} />,
                },
                {
                  name: 'Twitter',
                  value: 443232,
                  icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} />,
                },
              ]}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppTasks
              title="Tasks"
              list={[
                { id: '1', label: 'Create FireStone Logo' },
                { id: '2', label: 'Add SCSS and JS files if required' },
                { id: '3', label: 'Stakeholder Meeting' },
                { id: '4', label: 'Scoping & Estimations' },
                { id: '5', label: 'Sprint Showcase' },
              ]}
            />
          </Grid> */}
        </Grid>
      </Container>








      <Modal open={openDown} onClose={handleCloseDown} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillsetDown]}>
          {/* <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                  Set Priority
                </Typography> */}

          <Divider />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid container sx={{ flexDirection: "row", mt: 0.6 }} spacing={2}>
              <Grid item xs={6} sx={{}}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From"
                      slotProps={{ textField: {} }}
                      value={ValuesDown.fromDate ? dayjs(ValuesDown.fromDate) : null}

                      onChange={(date) => handleDateChangeDown(date, 'fromDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{}}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Till"
                      slotProps={{ textField: {} }}
                      value={ValuesDown.tillDate ? dayjs(ValuesDown.tillDate) : null}

                      onChange={(date) => handleDateChangeDown(date, 'tillDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '12%', mt: 2.6 }}
                disabled={!(ValuesDown.tillDate && ValuesDown.fromDate)}
              //  onClick={()=>download(row)}
              >
                Download
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

    </>
  );
}
